/**
 * Los textos del portal del socio, en castellano.
 *
 * Es el diccionario de referencia: las claves que hay aquí son las que tiene
 * que tener cada idioma (el compilador obliga, ver ca.ts). Se escribe la
 * frase entera, no trozos: «Tu cuota vence en {dias}» y no «Tu cuota vence»
 * + «en» + número, porque cada idioma ordena las palabras a su manera y un
 * texto montado a trozos solo suena bien en el idioma en que se montó.
 *
 * Las variables van entre llaves: {nombre}, {dias}. Los plurales llevan la
 * unidad ya concordada por `dias()` o `plural()` en la pantalla.
 */
export const es = {
  // --- General ---
  "general.cargando": "Cargando...",
  "general.unMomento": "Un momento...",
  "general.guardando": "Guardando...",
  "general.guardar": "Guardar",
  "general.guardado": "Guardado",
  "general.cancelar": "Cancelar",
  "general.cerrar": "Cerrar",
  "general.volver": "Volver",
  "general.salir": "Salir",
  "general.entrar": "Entrar",
  "general.enviando": "Enviando...",
  "general.idioma": "Idioma",
  "general.o": "o",
  "general.fallo": "No se pudo completar la operación",

  // El titulo de la pestaña: a menudo hay varias abiertas.
  "titulo.gestion": "Gestión del club",
  "titulo.portal": "Mi club",
  "titulo.carta": "Carta del local",
  "titulo.plataforma": "Panel de plataforma",
  "titulo.web": "asocis · Gestión de asociaciones cannábicas",
  "titulo.prueba": "Pedir una prueba · asocis",

  // Lo que queda escrito debajo del icono cuando el socio se instala el
  // portal en el movil. De aqui salen los cinco public/manifest-*.webmanifest:
  // si se cambia un texto, hay que rehacerlos.
  "manifiesto.nombre": "Portal del socio",
  "manifiesto.descripcion":
    "Tu carnet, tu consumo, tu cuota y las noticias de tu asociación.",

  // La pantalla que el club cuelga en su local. Habla el idioma del club:
  // es la unica que no elige quien la mira.
  "carta.cargando": "Cargando la carta…",
  "carta.noDisponible": "Carta no disponible",
  "carta.noDisponibleAyuda":
    "Comprueba el enlace, o pide al club que active la carta desde sus ajustes.",
  "carta.sinProducto": "Ahora mismo no hay producto disponible.",
  "carta.pie": "Aportación solidaria para socios · Actualizado a las {hora}",
  "carta.pieSinConexion":
    "Aportación solidaria para socios · Actualizado a las {hora} · sin conexión, puede estar desfasado",
  "unidad.dia": "día",
  "unidad.dias": "días",

  // --- Etiquetas de códigos que manda el servidor ---
  // El concepto de cada apunte del monedero y de cada cuota.
  //
  // La fila guarda su clave y no solo su rotulo, igual que guarda el metodo de
  // pago aparte: una frase hecha no se puede traducir luego. El socio holandes
  // abria su monedero -la pantalla que mira para cuadrarlo- y lo leia entero en
  // castellano. Lo que escribe el club de su mano no lleva clave y no se toca.
  "mov.recarga.EFECTIVO": "Recarga en efectivo",
  "mov.recarga.TARJETA": "Recarga con tarjeta",
  "mov.recarga.TRANSFERENCIA": "Recarga por transferencia",
  "mov.devolucion": "Devolución de saldo",
  "mov.dispensacion": "Dispensación #{numero}",
  "mov.dispensacionAnulada": "Anulación de la dispensación #{numero}",
  "mov.barra": "Barra #{numero}",
  "mov.barraAnulada": "Anulación de la barra #{numero}",
  "mov.donacion": "Donación al club",
  "cuota.anual": "Cuota anual",
  "cuota.anios": "Cuota de {n} años",
  "cuota.unMes": "Cuota de un mes",
  "cuota.meses": "Cuota de {n} meses",
  "cuota.alta": "Cuota de alta",
  "pago.EFECTIVO": "Efectivo",
  "pago.CARTERA": "Cartera",
  "pago.TARJETA": "Tarjeta",
  "pago.TRANSFERENCIA": "Transferencia",
  "movimiento.RECARGA": "Recarga",
  "movimiento.CONSUMO": "Consumo",
  "movimiento.DEVOLUCION": "Devolución",
  "movimiento.AJUSTE": "Ajuste",
  "movimiento.CUOTA": "Cuota",
  "genetica.SATIVA": "Sativa",
  "genetica.INDICA": "Índica",
  "genetica.HIBRIDA": "Híbrida",
  "genetica.CBD": "CBD",
  "genetica.NA": "—",

  // --- Cabecera y pestañas ---
  "portal.cabecera.socioNumero": "{nombre} · socio nº {numero}",
  "portal.cabecera.contrasena": "Contraseña",
  "portal.pestana.inicio": "Mi carnet",
  "portal.pestana.catalogo": "Disponible",
  "portal.pestana.reservas": "Mis reservas",
  "portal.pestana.noticias": "Noticias",
  "portal.pestana.valoraciones": "Opinar",
  "portal.pestana.historial": "Mi historial",
  "portal.pestana.contrato": "Contrato",

  // --- Entrada ---
  "entrada.titulo": "Portal del socio",
  "entrada.subtituloEntrar": "Consulta tu consumo, tu cuota y tu carnet",
  "entrada.subtituloActivar": "Estrena tu acceso con el código del club",
  "entrada.club": "Club",
  "entrada.clubAyuda": "El identificador que te ha dado la asociación.",
  "entrada.numeroSocio": "Número de socio",
  "entrada.codigo": "Código de activación",
  "entrada.codigoAyuda": "Te lo dan en el mostrador. Caduca a los 7 días.",
  "entrada.contrasena": "Contraseña",
  "entrada.eligeContrasena": "Elige una contraseña",
  "entrada.minimo8": "Mínimo 8 caracteres.",
  "entrada.repiteContrasena": "Repite la contraseña",
  "entrada.crearAcceso": "Crear mi acceso",
  "entrada.primeraVez": "¿Primera vez?",
  "entrada.activarAcceso": "Activar mi acceso",
  "entrada.yaTengoContrasena": "Ya tengo contraseña",
  "entrada.noCoinciden": "Las dos contraseñas no coinciden",
  "entrada.accesoCreado": "Acceso creado. Ya puedes entrar con tu contraseña.",

  // --- Inicio (carnet) ---
  "inicio.cuotaVencioHace":
    "Tu cuota venció hace {dias}. Pásate por el club para renovarla.",
  "inicio.cuotaVenceHoy": "Tu cuota vence hoy.",
  "inicio.cuotaVenceEn": "Tu cuota vence en {dias}.",
  "inicio.socio": "Socio",
  "inicio.numero": "Nº {numero}",
  "inicio.socioDesde": "Socio desde {fecha}",
  "inicio.cuotaValidaHasta": "Cuota válida hasta {fecha}",
  "inicio.generando": "Generando…",
  "inicio.ensenaCodigo":
    "Enseña este código en el mostrador para identificarte.",
  "inicio.tuConsumo": "Tu consumo",
  "inicio.hoy": "Hoy",
  "inicio.esteMes": "Este mes",
  "inicio.puedesRetirar": "Puedes retirar ahora",
  "inicio.tuCartera": "Tu cartera",
  "inicio.saldoDisponible":
    "Saldo disponible para tus aportaciones. Se recarga en el mostrador.",
  "inicio.tuClub": "Tu club",
  "inicio.telefono": "Teléfono:",

  // --- Avisos ---
  "avisos.titulo": "Avisos del club",
  "avisos.noSoportado":
    "Este navegador no admite avisos. Puedes consultar las noticias entrando al portal.",
  "avisos.requiereInstalar1":
    "En iPhone hay que añadir antes el portal a la pantalla de inicio: toca",
  "avisos.compartir": "Compartir",
  "avisos.yLuego": "y luego",
  "avisos.anadirAInicio": "Añadir a pantalla de inicio",
  "avisos.requiereInstalar2": "Después podrás activar los avisos desde aquí.",
  "avisos.activados":
    "Recibes un aviso en este dispositivo cuando el club publica una noticia.",
  "avisos.sinActivar":
    "Activa los avisos para enterarte de las novedades del club sin entrar.",
  "avisos.desactivar": "Desactivar avisos",
  "avisos.activar": "Activar avisos",
  "avisos.enviarPrueba": "Enviar una prueba",
  "avisos.yaNo": "Ya no recibirás avisos en este dispositivo.",
  "avisos.listo": "Listo. Te avisaremos cuando el club publique algo.",
  "avisos.bloqueados":
    "Tu navegador tiene bloqueadas las notificaciones para esta página. Puedes desbloquearlas en sus ajustes.",
  "avisos.fallo":
    "No se pudieron activar los avisos. Inténtalo de nuevo más tarde.",
  "avisos.pruebaEnviada":
    "Aviso de prueba enviado: debería llegarte en unos segundos.",
  "avisos.pruebaFallo": "No se pudo enviar el aviso de prueba.",

  // --- Catálogo y reservas ---
  "catalogo.vacio": "El club no tiene productos publicados ahora mismo.",
  "catalogo.condiciones":
    "Las aportaciones ya llevan tus condiciones de socio. La disponibilidad puede cambiar durante el día.",
  "catalogo.sinSaldo":
    "Para reservar necesitas saldo en tu cartera. Pásate por el club para recargarla y podrás pedir desde aquí.",
  "catalogo.sinStock": "Sin stock",
  "catalogo.quitarGramo": "Quitar un gramo",
  "catalogo.anadirGramo": "Añadir un gramo",
  "catalogo.faltan": "Te faltan {importe} en la cartera",
  "catalogo.quedarian": "Te quedarían {importe} en la cartera",
  "catalogo.vaciar": "Vaciar",
  "catalogo.reservar": "Reservar",
  "catalogo.reservando": "Reservando...",
  "catalogo.falloReserva": "No se pudo hacer la reserva",
  "reservas.vacio":
    "Todavía no has reservado nada. Desde «Disponible» puedes pedir lo que quieras y pasar a recogerlo.",
  "reservas.titulo": "Reserva {numero}",
  "reservas.PENDIENTE": "Pendiente",
  "reservas.PENDIENTE.explica": "El club aún no la ha preparado.",
  "reservas.PREPARADA": "Preparada",
  "reservas.PREPARADA.explica": "Ya la tienen lista. Pásate a recogerla.",
  "reservas.ENTREGADA": "Entregada",
  "reservas.ENTREGADA.explica": "Recogida.",
  "reservas.CANCELADA": "Cancelada",
  "reservas.CADUCADA": "Caducada",
  "reservas.CADUCADA.explica": "Pasó el plazo sin recogerla.",
  "reservas.total": "Total {cantidad}",
  "reservas.guardadaHasta":
    "Guardada hasta el {fecha}. Pasado ese día se anula sola.",
  "reservas.falloCancelar": "No se pudo cancelar",

  // --- Noticias ---
  "noticias.vacio": "El club todavía no ha publicado nada.",

  // --- Valoraciones ---
  "valoraciones.vacio":
    "Cuando te lleves algo, aquí podrás decir qué te ha parecido. Al club le sirve para saber qué vuelve a pedir.",
  "valoraciones.intro":
    "Di qué te ha parecido lo que te has llevado. Lo lee el club, para saber qué vuelve a pedir.",
  "valoraciones.nDe5": "{n} de 5",
  "valoraciones.comentario": "Algo que quieras contar (opcional)",

  // --- Historial ---
  "historial.retiradas": "Tus retiradas",
  "historial.sinRetiradas": "Todavía no has retirado nada.",
  "historial.fecha": "Fecha",
  "historial.productos": "Productos",
  "historial.cantidad": "Cantidad",
  "historial.aportacion": "Aportación",
  "historial.anulada": "Anulada",
  "historial.cartera": "Movimientos de tu cartera",
  "historial.sinMovimientos": "Sin movimientos.",
  "historial.concepto": "Concepto",
  "historial.importe": "Importe",
  "historial.saldo": "Saldo",
  "historial.cuotas": "Tus cuotas",
  "historial.sinCuotas": "Sin cuotas registradas.",
  "historial.validaHasta": "Válida hasta",

  // --- Contrato ---
  "contrato.sinPublicar":
    "Tu asociación todavía no ha publicado aquí su contrato de socio.",
  "contrato.aceptaste": "Aceptaste la",
  "contrato.version": "versión {numero}",
  "contrato.elDia": "el {fecha}",
  "contrato.esLaQueAplica": ". Es la que se te aplica.",
  "contrato.leeConCalma":
    "Léelo con calma. Al aceptarlo queda constancia de la fecha y de la versión, y podrás volver a leerlo aquí siempre que quieras.",
  "contrato.versionNueva":
    "La asociación ha publicado una versión más nueva. Lo que firmaste sigue siendo lo de arriba; pregunta en el local si quieres aceptar la nueva.",
  "contrato.aceptar": "He leído y acepto el contrato",
  "contrato.falloGuardar": "No se pudo guardar",

  // --- Contraseña ---
  "contrasena.titulo": "Cambiar mi contraseña",
  "contrasena.actual": "Contraseña actual",
  "contrasena.nueva": "Nueva contraseña",
  "contrasena.repite": "Repite la nueva",
  "contrasena.cambiar": "Cambiar",
  "contrasena.cambiada": "Contraseña cambiada.",
  "contrasena.fallo": "No se pudo cambiar la contraseña",

  // --- Solicitud de alta ---
  "alta.titulo": "Solicitar el alta",
  "alta.clubNoEncontrado":
    "No encontramos ese club. Revisa el enlace que te han dado.",
  "alta.nombre": "Nombre *",
  "alta.apellidos": "Apellidos *",
  "alta.documento": "Documento",
  "alta.pasaporte": "Pasaporte",
  "alta.numero": "Número *",
  "alta.fechaNacimiento": "Fecha de nacimiento *",
  "alta.mayorDeEdad": "Hay que ser mayor de 18 años.",
  "alta.telefono": "Teléfono",
  "alta.email": "Email",
  "alta.ciudad": "Ciudad",
  "alta.avalista": "Nº del socio que te avala",
  "alta.avalistaAyuda": "Si alguien de la asociación te presenta.",
  "alta.mensaje": "Mensaje para el club",
  "alta.consentimiento":
    "Acepto que la asociación trate mis datos para estudiar esta solicitud.",
  "alta.consentimientoAyuda":
    "Si la rechazan, tus datos quedan solo en su registro interno.",
  "alta.enviar": "Enviar solicitud",
  "alta.yaSoySocio": "Ya soy socio",
  "alta.enviada": "Solicitud enviada",
  "alta.enviadaTexto":
    "{club} la revisará y se pondrá en contacto contigo. Recuerda que el alta se completa en el local, presentando tu documento.",
  "alta.elClub": "El club",
  "alta.fallo": "No se pudo enviar la solicitud",

  // --- Lo que dice el servidor y el portal traduce ---
  // --- Lo que sale mal, dicho en el idioma de quien lo lee ---
  //
  // El servidor manda la frase en castellano y la clave con la que decirla
  // aqui. Sin esto el portal estaba entero en el idioma del socio hasta que
  // algo le salia mal, y justo entonces le hablaba en otro.
  "err.clubNoEncontrado": "No encontramos ese club",
  "err.codigoNoValido": "El número de socio o el código no son correctos, o el código ha caducado",
  "err.entradaIncorrecta": "Número de socio o contraseña incorrectos",
  "err.passwordActualMal": "La contraseña actual no es correcta",
  "err.soloLoQueTeLlevaste": "Solo se puede valorar lo que te has llevado",
  "err.sinContrato": "Este club todavía no tiene contrato de socio",
  "err.reservaNoEncontrada": "No encontramos esa reserva",
  "err.reservaNoPendiente": "Esta reserva ya no está pendiente",
  "err.reservaCerrada": "Esta reserva ya está cerrada",
  "err.yaTienesReserva":
    "Ya tienes la reserva número {numero} pendiente de recoger. Cancélala si quieres pedir otra cosa.",
  "err.productoNoEncontrado": "No encontramos ese producto",
  "err.pasaDelMes": "Lo que pides pasa de lo que te queda este mes. Te quedan {cantidad}.",
  "err.sinSaldo":
    "Para reservar necesitas saldo en tu cartera. Lo que pides son {total} y tienes {saldo}. Pásate por el club para recargar y vuelve a intentarlo.",
  "err.mayorDeEdad": "Hay que ser mayor de 18 años",
  "err.nacimientoNoValido": "La fecha de nacimiento no es válida",
  "err.consentimiento": "Hay que aceptar el tratamiento de datos",
  "err.idiomaNoExiste": "Ese idioma no existe",
  "err.bloqueo.baja": "Tu alta está dada de baja. Habla con el club.",
  "err.bloqueo.suspendido": "Tu alta está suspendida. Habla con el club.",
  "err.bloqueo.pendiente": "Tu alta está pendiente de validar. Pásate por el club para terminarla.",
  "err.bloqueo.cuotaCaducada": "Tu cuota está caducada. Pásate por el club para renovarla.",
  "err.bloqueo.cuotaVencida": "Tu cuota ha vencido: hay que renovarla. Pásate por el club.",
  "servidor.El socio está dado de baja": "El socio está dado de baja",
  "servidor.El socio está suspendido": "El socio está suspendido",
  "servidor.El alta del socio está pendiente de validar":
    "El alta del socio está pendiente de validar",
  "servidor.La cuota del socio está caducada":
    "La cuota del socio está caducada",
  "servidor.La cuota del socio ha caducado: hay que renovarla":
    "La cuota del socio ha caducado: hay que renovarla",

  // --- Web pública: portada ---
  "web.entrar": "Entrar",
  "web.frase":
    "asocis es el programa para llevar una asociación cannábica: socios, mostrador, inventario por lotes, caja y portal del socio.",
  "web.fraseSegunda":
    "Lo de abajo es su mostrador, funcionando con datos inventados. Elige un socio, toca productos, pásate de su límite, cobra.",
  "web.altasUnaAUna":
    "Las altas van una a una: te damos un código y con él montas tu club en un minuto.",
  "web.yaTienesUno": "¿Ya tienes uno?",
  "web.pedirPrueba": "Pedir una prueba",
  "web.pedirAcceso": "Pedir acceso",
  "web.probarGratis": "Probar {dias} gratis",
  "web.crearClub": "Crear mi club",
  "web.pieDemo":
    "Con tus datos hace lo mismo. Lo que no cabe aquí: el buscador por nombre, número o documento; el lector del carnet QR; las categorías del catálogo; los descuentos a mano; y el resto del menú.",

  // --- Web pública: lo que hay detrás ---
  "web.detras": "Lo que hay detrás del mostrador",
  "web.detras.socios": "Socios",
  "web.detras.socios.texto":
    "Alta con documento, foto, avalista, consumo declarado y consentimiento con fecha. Tipos de socio con su cuota, su descuento y sus límites. El libro de socios que la asociación está obligada a llevar, listo para imprimir. Y «Importar CSV» para traerlos de tu programa anterior.",
  "web.detras.limites": "Límites",
  "web.detras.limites.texto":
    "Cada socio tiene un tope diario y otro mensual. El mostrador compara el pedido con lo que lleva; si se pasa, hay que autorizarlo y queda apuntado quién lo hizo. Un socio con la cuota caducada no dispensa hasta renovar.",
  "web.detras.inventario": "Inventario por lotes",
  "web.detras.inventario.texto":
    "Las entradas van por lote, con proveedor, coste y caducidad. El mostrador consume del más antiguo, las mermas llevan motivo y los recuentos comparan lo contado con lo que tendría que haber. Cada gramo entregado se sabe de qué lote salió.",
  "web.detras.caja": "Caja",
  "web.detras.caja.texto":
    "El turno abre con un fondo, recoge dispensaciones, barra y gastos en efectivo, y al cerrar se cuenta el cajón: el programa dice lo que debería haber y la diferencia. Los gastos domiciliados no tocan la caja.",
  "web.detras.cartera": "Cartera",
  "web.detras.cartera.texto":
    "Monedero prepago del socio: recargas, consumo, devoluciones. En el mostrador se cobra de la cartera de un toque, y si no cubre, lo dice.",
  "web.detras.barra": "Barra",
  "web.detras.barra.texto":
    "Cafés, refrescos y snacks con su carta y su cobro rápido. Van a la misma caja, pero el arqueo distingue barra de dispensación.",
  "web.detras.portal": "Portal del socio",
  "web.detras.portal.texto":
    "En su móvil, como una aplicación: el carnet con QR para identificarse en el mostrador, su consumo frente a sus límites, su cartera, el catálogo con su precio, las noticias del club y reservas para pasar a recoger. En {idiomas}.",
  "web.detras.cuotas": "Cuotas y renovaciones",
  "web.detras.cuotas.texto":
    "Cobro, vencimientos, y un recordatorio por correo antes de que caduquen. Las donaciones van aparte, para que no muevan la fecha de nadie.",
  "web.detras.gastos": "Gastos y compras",
  "web.detras.gastos.texto":
    "Lo que se debe al proveedor y lo que se pagó, con categoría, en la misma pantalla. Exportación para la gestoría.",
  "web.detras.acceso": "Acceso y aforo",
  "web.detras.acceso.texto":
    "Quién está dentro ahora y cuánta gente ha pasado hoy. Con aforo, al llenarse avisa: no cierra la puerta.",
  "web.detras.informes": "Informes",
  "web.detras.informes.texto":
    "De dónde viene el dinero por día o por mes, separando dispensación, barra y cuotas. Ranking de productos y de socios.",
  "web.detras.carta": "Carta para la pantalla del local",
  "web.detras.carta.texto":
    "Una página a pantalla completa con lo que hay hoy y su precio, que aguanta un corte de red.",

  // --- Web pública: precio ---
  "web.precio": "Precio",
  "web.precio.texto":
    "Va por tamaño, y cuentan los socios <b>activos</b>: las bajas de años anteriores no te suben el precio. Todas las funciones y todo el equipo entran en cualquier tramo.",
  "web.precio.sociosActivos": "Socios activos",
  "web.precio.alMes": "Al mes",
  "web.precio.hablamos": "Hablamos",
  "web.precio.consultanos": "Consúltanos",
  "web.tramo.hasta": "Hasta {hasta} socios", // siempre plural: un tramo no es de un socio
  "web.tramo.entre": "De {desde} a {hasta} socios", // siempre plural: un tramo no es de un socio
  "web.tramo.mas": "Más de {desde} socios", // siempre plural: un tramo no es de un socio
  "web.precio.prueba": "{dias} de prueba para verlo con tus datos de verdad.",
  "web.precio.condiciones":
    "Sin permanencia: si lo dejas, te llevas tus datos, y puedes descargarte el club entero en un fichero cuando quieras, también el día que te vas. Si el club crece y cambia de tramo, te avisamos antes; nunca se bloquea nada. Las actualizaciones van incluidas.",

  // --- Web pública: datos y cómo se empieza ---
  "web.datos": "Sobre los datos",
  "web.datos.texto":
    "Un club maneja documentos de identidad, fotos y consumo de sus socios: datos personales de gente de verdad. Cada club está aislado de los demás, las contraseñas se guardan cifradas y todo lo que se hace queda en un registro de actividad con quién y cuándo. Se hace una copia de seguridad de cada club todas las noches, y el club puede descargarla él mismo. La tablet del mostrador se bloquea sola si nadie la toca.",
  "web.datos.nota":
    "El programa te da las herramientas; el contrato de encargado del tratamiento con tus socios y la política de conservación los defines tú, como con cualquier otro proveedor.",
  "web.empezar": "Cómo se empieza",
  "web.empezar.nosEscribes": "Nos escribes",
  "web.empezar.conCodigo":
    "y te contestamos con un código de alta. Van de una en una a propósito: cada club empieza con alguien al otro lado.",
  "web.empezar.creasClub": "Creas tu club",
  "web.empezar.sinCodigo":
    "con el nombre, los datos de la asociación y tu cuenta de propietario. Un minuto.",
  "web.empezar.despues":
    "Después pones tus tipos de socio, la cuota, los límites y el catálogo —lo que no pongas tiene un valor razonable de serie—, y traes a tus socios con «Importar CSV», que lee el registro de tu programa anterior. El mismo día ya tienes mostrador.",
  "web.pie": "asocis · Gestión de asociaciones cannábicas",
  "web.pie.avisoLegal": "Aviso legal",
  "web.pie.privacidad": "Privacidad",

  // --- Mostrador de muestra ---
  "web.demoEnCastellano":
    "Este mostrador de muestra está solo en castellano; el programa de verdad y el portal del socio están en {idiomas}.",
  "prueba.titulo": "Pedir una prueba",
  "prueba.intro":
    "Las altas van una a una: te contestamos con un código y con él montas tu club en un minuto. Si nos dices cuántos socios tenéis, te decimos ya lo que os toca pagar.",
  "prueba.nombreClub": "Nombre de la asociación",
  "prueba.ciudad": "Ciudad",
  "prueba.socios": "Socios, aproximadamente",
  "prueba.sociosAyuda": "Opcional. Es lo que decide el precio.",
  "prueba.tuNombre": "Tu nombre",
  "prueba.tuEmail": "Tu email",
  "prueba.tuEmailAyuda": "Ahí te mandamos el código.",
  "prueba.telefono": "Teléfono",
  "prueba.telefonoAyuda": "Opcional, por si es más fácil llamarte.",
  "prueba.mensaje": "¿Algo que debamos saber?",
  "prueba.mensajeAyuda":
    "Opcional. Cómo lo lleváis ahora, qué os falta, cuándo queréis empezar.",
  "prueba.privacidad1": "He leído la",
  "prueba.privacidad2": "política de privacidad",
  "prueba.privacidad3": "y acepto que uséis estos datos para contestarme.",
  "prueba.enviar": "Pedir la prueba",
  "prueba.fallo": "No se pudo enviar la solicitud",
  "prueba.recibido": "Recibido.",
  "prueba.recibidoTexto1": "Te escribimos a",
  "prueba.recibidoTexto2": "con el código para dar de alta",
  "prueba.recibidoTexto3":
    ", normalmente en un día laborable. Si no lo ves, mira en el correo no deseado.",
  "prueba.volverWeb": "Volver a la web",

  // --- Gestión: piezas comunes ---
  "g.cargando": "Cargando...",
  "g.cancelar": "Cancelar",
  "g.cerrar": "Cerrar",
  "g.guardar": "Guardar",
  "g.anterior": "Anterior",
  "g.siguiente": "Siguiente",
  "g.pagina": "Página {pagina} de {paginas}",
  "g.estado.ACTIVO": "Activo",
  "g.estado.PENDIENTE": "Pendiente",
  "g.estado.CADUCADO": "Caducado",
  "g.estado.SUSPENDIDO": "Suspendido",
  "g.estado.BAJA": "Baja",

  // --- Gestión: mostrador ---
  "m.titulo": "Mostrador",
  "m.descripcion": "Registro de entrega a socio",
  "m.dudaDeGuardado1": "Mira en",
  "m.dudaDeGuardado2":
    "si la entrega llegó a registrarse. Si está, no la repitas.",
  "m.dispensaciones": "Dispensaciones",
  "m.reservas": "Reservas por recoger",
  "m.socio": "Socio",
  "m.pedido": "Pedido",
  "m.total": "Total",
  "m.reservaNumero": "Reserva {numero}",
  "m.faltaGenero": "Falta género",
  // Cancelar el pedido de un socio desde el mostrador. El motivo lo lee el
  // socio en su portal, asi que se pide: es la diferencia entre «no nos queda
  // Amnesia, pasate y te lo cambiamos» y que le desaparezca sin saber por que.
  "m.cancelarReserva": "Cancelar",
  "m.can.titulo": "Cancelar la reserva #{numero}",
  "m.can.quePasa":
    "El socio verá la reserva cancelada con el motivo que escribas y podrá volver a pedir. Si tiene el portal en el móvil, le llega un aviso.",
  "m.can.motivo": "Motivo, que lo lee el socio",
  "m.can.confirmar": "Sí, cancela la reserva",
  "m.can.fallo": "No se pudo cancelar la reserva",
  "m.can.hecho": "Reserva cancelada",
  "m.atender": "Atender",
  "m.aQuien": "¿A quién se dispensa?",
  "m.comoBuscar":
    "Escribe al menos dos letras del nombre, el número de socio o el documento.",
  "m.todo": "Todo",
  "m.sinProductos": "No hay productos disponibles en esta categoría.",
  // Lo que ya tienen pedido otros socios, al lado del stock. Reservar no
  // retiene genero, asi que sin esto el mostrador no sabe lo que debe.
  "m.reservado": "{cantidad} reservados",
  "m.sinStock": "Sin stock",
  "m.cambiar": "Cambiar",
  "m.hoy": "Hoy",
  "m.esteMes": "Este mes",
  "m.cartera": "Cartera",
  "m.ingresar": "+ Ingresar",
  "m.ingresarTitulo": "Ingresar dinero en su cartera",
  "m.cuotaVencioHace": "La cuota venció hace {dias}.",
  "m.cuotaVenceHoy": "La cuota vence hoy.",
  "m.cuotaVenceEn": "La cuota vence en {dias}.",
  "m.cobrarAhora": "Cobrar ahora",
  "m.entrega": "Entrega",
  "m.tocaProducto": "Toca un producto para añadirlo.",
  "m.quitar": "Quitar",
  "m.ahorro": "Ahorro {importe}",
  "m.descuentoAMano": "Descuento a mano −{importe}",
  "m.descuento": "Descuento",
  "m.quitarDescuento": "Quitar el descuento",
  "m.hacerDescuento": "Hacer descuento",
  "m.superaLimiteCorto": "Supera el límite disponible ({disponible}).",
  "m.registrando": "Registrando...",
  "m.registrar": "Registrar entrega · {total}",
  "m.irACobrar": "Ir a cobrar",
  "m.falloRegistrar": "No se pudo registrar la dispensación",
  "m.superaLimite":
    "Supera el límite disponible: puede llevarse {disponible} y se piden {pedido}",
  "m.soloPropietario":
    "Solo un encargado o superior puede autorizar pasar del límite",

  // --- Mostrador: avisos y ventanas ---
  "m.sinFichar.titulo": "No ha fichado la entrada",
  "m.sinFichar.texto":
    "no consta dentro del local. Puedes ficharle la entrada ahora y seguir con la entrega.",
  "m.sinFichar.nota":
    "Si sigues sin fichar, la entrega se registra igual, pero el socio no contará en el aforo ni en el libro de entradas del día.",
  "m.sinFichar.seguir": "Seguir sin fichar",
  "m.sinFichar.fichar": "Fichar y seguir",
  "m.sinFichar.fichando": "Fichando...",
  "m.sinFichar.fallo": "No se pudo fichar la entrada",
  "m.limite.titulo": "Se supera el límite",
  "m.limite.autorizar": "Autorizar y registrar",
  "m.limite.nota":
    "Solo un encargado o superior puede autorizarlo. La autorización queda registrada en el historial de auditoría con tu nombre.",
  "m.venta.enCola": "Entrega guardada en esta tablet",
  "m.venta.registrada": "Entrega #{numero} registrada",
  "m.venta.quedan": "Quedan {importe} en la cartera",

  // --- Gestión: socios ---
  "s.titulo": "Socios",
  "s.enElRegistro": "{socios} en el registro",
  "s.exportar": "Exportar CSV",
  "s.libro": "Libro de socios",
  "s.importar": "Importar CSV",
  "s.carnets": "Carnets",
  "s.nuevo": "+ Nuevo socio",
  "s.falloExportar": "No se pudo exportar",
  "s.buscar": "Buscar por nombre, número o documento...",
  "s.todosLosEstados": "Todos los estados",
  "s.cualquierTipo": "Cualquier tipo",
  "s.hanVenidoDesde": "Han venido desde",
  "s.sinCoincidencias": "No hay socios que coincidan con la búsqueda.",
  "s.sinSocios": "Todavía no hay socios.",
  "s.darDeAlta": "Dar de alta al primero",
  "s.oImportar": "importar los que ya tenéis",
  "s.numero": "Nº",
  "s.socio": "Socio",
  "s.documento": "Documento",
  "s.estado": "Estado",
  "s.cuotaHasta": "Cuota hasta",
  "s.ultimaVisita": "Última visita",
  "s.aportado": "Aportado",
  "s.cartera": "Cartera",
  "s.anios": "{anios} años",
  "s.sinTelefono": "sin teléfono",
  "s.queda": "queda {dias}",
  "s.quedan": "quedan {dias}",
  "s.nunca": "Nunca",
  "s.hoy": "hoy",
  "s.ayer": "ayer",
  "s.haceDias": "hace {dias} días",
  "s.haceUnMes": "hace un mes",
  "s.haceMeses": "hace {meses} meses",
  "s.haceUnAnio": "hace un año",
  "s.haceAnios": "hace {anios} años",

  // --- Buscador de socios (mostrador y accesos) ---
  "b.marcador": "Buscar socio por nombre, número o DNI...",
  "b.escanear": "Escanear el carnet del socio",
  "b.sinCoincidencias": "Ningún socio coincide con «{texto}»",
  "b.codigoDesconocido":
    "Ese código no corresponde a ningún socio de este club.",
  "b.falloCodigo": "No se pudo comprobar el código. Inténtalo de nuevo.",
  "b.escanearBoton": "Escanear",
  "b.qr.sinCamara": "Este navegador no da acceso a la camara. Escribe el número de socio a mano.",
  "b.qr.sinPermiso": "No has dado permiso para usar la camara. Puedes darlo en el candado de la barra de direcciones.",
  "b.qr.sinDispositivo": "No se ha encontrado ninguna camara en este dispositivo.",
  "b.qr.falloCamara": "No se pudo abrir la camara. Escribe el número de socio a mano.",
  "b.qr.apunta": "Apunta al código del socio. Se identifica solo en cuanto lo lea.",
  "m.productos": "{n} productos", // siempre plural: el singular es m.unProducto
  "m.unProducto": "1 producto",

  // --- Gestión: caja ---
  "c.titulo": "Caja",
  "c.descripcion": "Turnos de caja y arqueo del efectivo",
  "c.entradaSalida": "Entrada / salida",
  "c.cerrarCaja": "Cerrar caja",
  "c.abrirCaja": "Abrir caja",
  "c.sinCaja":
    "No tienes ninguna caja abierta. Mientras siga cerrada, los cobros en efectivo no se anotarán en ningún arqueo.",
  "c.otraAbierta":
    "Hay otra caja abierta en el club, y lo que cobres tú no entra ahí.",
  "c.otrasAbiertas":
    "Hay otras {n} cajas abiertas en el club, y lo que cobres tú no entra ahí.",
  "c.fondoInicial": "Fondo inicial",
  "c.abiertaALas": "Abierta a las {hora}",
  "c.dispensaciones": "Dispensaciones",
  "c.barra": "Barra",
  "c.cuotasYRecargas": "Cuotas y recargas",
  "c.gastos": "Gastos",
  "c.deberiaHaber": "Debería haber",
  "c.formula": "Fondo + entradas − salidas",
  "c.movimientos": "Movimientos del turno",
  "c.sinMovimientos": "Todavía no hay movimientos en este turno.",
  "c.hora": "Hora",
  "c.tipo": "Tipo",
  "c.concepto": "Concepto",
  "c.usuario": "Usuario",
  "c.importe": "Importe",
  "c.historial": "Historial de turnos",

  "c.fa.titulo": "Efectivo fuera de arqueo",
  "c.fa.explicacion":
    "{cuantos} veces se cobró en efectivo sin ninguna caja abierta, {importe} en total: ese dinero está en el cajón y no entra en el arqueo de ningún turno. Pasa cuando se cobra con la caja cerrada, y con las entregas hechas sin red que se envían cuando el turno de quien las hizo ya terminó.",
  "c.fa.explicacionUno":
    "Un cobro de {importe} en efectivo se hizo sin ninguna caja abierta: ese dinero está en el cajón y no entra en el arqueo de ningún turno. Pasa cuando se cobra con la caja cerrada, y con las entregas hechas sin red que se envían cuando el turno de quien las hizo ya terminó.",
  "c.fa.cuando": "Cuándo",
  "c.fa.que": "Qué",
  "c.fa.importe": "Importe",
  "c.fa.hayMas": "Solo se ven los 100 más recientes.",
  "c.fa.tipo.DISPENSACION": "Dispensación",
  "c.fa.tipo.BARRA": "Barra",
  "c.fa.tipo.CUOTA": "Cuota",
  "c.fa.tipo.DONACION": "Donación",
  "c.fa.tipo.RECARGA": "Recarga",
  "c.fa.tipo.GASTO": "Gasto",
  "c.sinTurnos": "Aún no se ha cerrado ningún turno.",
  "c.apertura": "Apertura",
  "c.cierre": "Cierre",
  "c.responsable": "Responsable",
  "c.teorico": "Teórico",
  "c.contado": "Contado",
  "c.diferencia": "Diferencia",
  "c.abierta": "Abierta",
  "c.cuadra": "Cuadra",
  "c.abrir.titulo": "Abrir caja",
  "c.abrir.fondo": "Fondo de caja inicial (créditos)",
  "c.abrir.fondoAyuda": "Dinero con el que empieza el turno.",
  "c.abrir.notas": "Notas",
  "c.abrir.notasEjemplo": "Turno de tarde...",
  "c.abrir.boton": "Abrir",
  "c.abrir.fallo": "No se pudo abrir la caja",
  "c.cerrar.titulo": "Cerrar caja",
  "c.cerrar.segunSistema": "Según el sistema debería haber",
  "c.cerrar.contado": "Dinero contado en el cajón (créditos)",
  "c.cerrar.descuadre": "Descuadre de",
  "c.cerrar.sobra": "(sobra dinero).",
  "c.cerrar.falta": "(falta dinero).",
  "c.cerrar.cuadra": "La caja cuadra exactamente.",
  "c.cerrar.observaciones": "Observaciones del cierre",
  "c.cerrar.boton": "Cerrar turno",
  "c.cerrar.fallo": "No se pudo cerrar la caja",
  "c.mov.titulo": "Movimiento de caja",
  "c.mov.tipo": "Tipo",
  "c.mov.salida": "Retirada de efectivo",
  "c.mov.entrada": "Entrada de efectivo",
  "c.mov.nota1": "Para una factura o una compra, usa",
  "c.mov.gastos": "Gastos",
  "c.mov.nota2": ": además de salir de la caja queda clasificada.",
  "c.mov.importe": "Importe (créditos)",
  "c.mov.concepto": "Concepto",
  "c.mov.conceptoEjemplo": "Compra de material...",
  "c.mov.boton": "Registrar",
  "c.mov.fallo": "No se pudo registrar el movimiento",
  "movimiento.ENTRADA": "Entrada",
  "movimiento.SALIDA": "Salida",
  "movimiento.DISPENSACION": "Dispensación",
  "movimiento.MERMA": "Merma",
  "movimiento.GASTO": "Gasto",

  // --- Gestión: inventario ---
  "i.titulo": "Inventario",
  "i.descripcion": "Entradas, mermas y recuentos de stock",
  "i.almacen": "Almacén",
  "i.movimientos": "Movimientos",
  "i.exportar": "Exportar CSV",
  "i.falloExportar": "No se pudo exportar",
  "i.enElMostrador": "En el mostrador",
  "i.valor": "Valor del inventario",
  "i.valorPie": "Según la aportación del catálogo",
  "i.coste": "Coste de lo que queda",
  "i.costePie": "Lo que se pagó por ello",
  "i.avisos": "Avisos",
  "i.avisosPie": "{bajos} bajo mínimo · {caducan} por caducar",
  "i.porCaducar": "Lotes próximos a caducar:",
  "i.buscar": "Buscar producto o categoría...",
  "i.nProductos": "{n} productos", // siempre plural: el singular es i.unProducto
  "i.unProducto": "1 producto",
  "i.sinProductos": "No hay productos. Créalos primero en el catálogo.",
  "i.producto": "Producto",
  "i.categoria": "Categoría",
  "i.unidad": "Unidad",
  "i.enVenta": "Mostrador",
  "i.guardado": "Guardado",
  "i.total": "Total",
  "i.minimo": "Mínimo",
  "i.lotes": "Lotes",
  "i.caduca": "Caduca",
  "i.valorColumna": "Valor",
  "i.costeColumna": "Coste",
  "i.bajoMinimo": "bajo mínimo",
  "i.inactivo": "Inactivo",
  "i.entrada": "Entrada",
  "i.merma": "Merma",
  "i.ajuste": "Ajuste",
  "i.ultimos": "Últimos movimientos",
  "i.sinRegistros": "Sin movimientos registrados.",
  "i.fecha": "Fecha",
  "i.tipo": "Tipo",
  "i.cantidad": "Cantidad",
  "i.op.entrada": "Entrada de {producto}",
  "i.op.merma": "Merma de {producto}",
  "i.op.ajuste": "Ajuste de {producto}",
  "i.op.stockActual": "Stock actual:",
  "i.op.cantidad": "Cantidad",
  "i.op.stockContado": "Stock real contado",
  "i.op.ajusteAyuda": "Se registrará la diferencia con el stock del sistema.",
  "i.op.codigoLote": "Código de lote",
  "i.op.codigoAyuda": "Se genera solo si lo dejas vacío.",
  "i.op.costeTotal": "Coste total (créditos)",
  "i.op.proveedor": "Origen / proveedor",
  "i.op.caducidad": "Caducidad",
  "i.op.motivo": "Motivo",
  "i.op.motivoAyuda": "Queda registrado en el historial.",
  "i.op.registrar": "Registrar",
  "i.op.fallo": "No se pudo registrar la operación",
  "i.gd.titulo": "Guardado · {producto}",
  "i.gd.enVenta": "Mostrador:",
  "i.gd.guardado": "Guardado:",
  "i.gd.queSeHace": "Qué se hace",
  "i.gd.aVenta": "Sacar del guardado al mostrador",
  "i.gd.aGuardado": "Retirar del mostrador al guardado",
  "i.gd.comoMucho": "Como mucho {cantidad}.",
  "i.gd.motivoAyuda": "Opcional. Queda en el historial de movimientos.",
  "i.gd.moviendo": "Moviendo...",
  "i.gd.sacar": "Sacar al mostrador",
  "i.gd.fallo": "No se pudo mover",
  "g.guardando": "Guardando...",
  "i.guardadosPie": "{cantidad} guardados",

  // --- Gestión: barra ---
  "ba.titulo": "Barra",
  "ba.descripcion": "Cafés, refrescos y todo lo que no es dispensación",
  "ba.carta": "Carta de la barra",
  "ba.vacia": "La carta de la barra está vacía.",
  "ba.vaciaAdmin": " Añade lo que vendéis con «Carta de la barra».",
  "ba.vaciaSocio": " Pídele a un administrador que la prepare.",
  "ba.sinExistencias": "Sin existencias",
  "ba.agotado": "Agotado",
  "ba.quedan": "Quedan {n}",
  "ba.cobro": "Cobro",
  "ba.tocaProducto": "Toca un producto para empezar.",
  "ba.cadaUno": "{importe} c/u",
  "ba.vaciar": "Vaciar",
  "ba.cobrando": "Cobrando...",
  "ba.cobrar": "Cobrar {total}",
  "ba.faltaSocio": "Para cobrar de la cartera hay que elegir al socio.",
  "ba.hoy": "Barra de hoy",
  "ba.unCobro": "1 cobro",
  "ba.cobros": "{n} cobros", // siempre plural: el singular es ba.unCobro
  "ba.ultimos": "Últimos cobros",
  "ba.sinCobros": "Hoy todavía no se ha cobrado nada en la barra.",
  "ba.anulada": "Anulada",
  "ba.falloCobrar": "No se pudo cobrar",
  "ba.cobrado": "Cobrado {importe} · ticket de barra {numero}",
  "ba.c.nombre": "Nombre",
  "ba.c.nombreEjemplo": "Café con leche",
  "ba.c.grupo": "Grupo",
  "ba.c.grupoAyuda": "Para agruparlos en la pantalla.",
  "ba.c.grupoPorDefecto": "Bebidas",
  "ba.c.precio": "Precio (créditos)",
  "ba.c.existencias": "Existencias",
  "ba.c.existenciasAyuda": "Solo si quieres llevar la cuenta.",
  "ba.c.llevarCuenta": "Llevar la cuenta de las existencias",
  "ba.c.llevarCuentaNota": "El café de la máquina no necesita cuenta; una caja de latas sí.",
  "ba.c.anadir": "Añadir a la carta",
  "ba.c.producto": "Producto",
  "ba.c.precioColumna": "Precio",
  "ba.c.quedan": "quedan {n}",
  "ba.c.quitar": "Quitar",
  "ba.c.reponer": "Reponer",
  "ba.c.fallo": "No se pudo guardar",

  // --- Gestión: dispensaciones ---
  "d.titulo": "Dispensaciones y barra",
  "d.descripcion": "Todo lo que ha salido, ticket a ticket",
  "d.a": "a",
  "d.exportar": "Exportar CSV",
  "d.falloExportar": "No se pudo exportar",
  "d.dispensario": "Dispensario",
  "d.barra": "Barra",
  "d.buscar": "Buscar socio, producto o nº de ticket",
  "d.atendioCualquiera": "Atendió cualquiera",
  "d.baja": " (baja)",
  "d.todosLosPuestos": "Todos los puestos",
  "d.todos": "Todos",
  "d.soloValidos": "Solo válidos",
  "d.soloAnulados": "Solo anulados",
  "d.quitarFiltros": "Quitar filtros",
  "d.entregas": "Entregas",
  "d.cobros": "Cobros",
  "d.unAnulado": "1 anulado",
  "d.anulados": "{n} anulados",
  "d.cantidad": "Cantidad",
  "d.aportaciones": "Aportaciones",
  "d.deDescuento": "{importe} de descuento",
  "d.aMano": "{importe} a mano",
  "d.sinCoincidencias": "Ningún ticket cuadra con lo que buscas.",
  "d.sinDispensaciones": "No hay dispensaciones en este periodo.",
  "d.sinCobros": "No se ha cobrado nada en la barra en este periodo.",
  "d.numero": "Nº",
  "d.fecha": "Fecha",
  "d.socio": "Socio",
  "d.productos": "Productos",
  "d.articulos": "Artículos",
  "d.descuento": "Descuento",
  "d.importe": "Importe",
  "d.atendio": "Atendió",
  "d.laSubio": "La subió {nombre}",
  "d.sinSocio": "Sin socio",
  "d.anulada": "Anulada",
  "d.sinConexion": "Sin conexión",
  "d.sinConexionAyuda": "Hecha sin red y enviada al volver la conexión",
  "d.descuentoAMano": "a mano {importe}",
  "d.ticket": "Ticket",
  "d.anular": "Anular",
  "d.tope":
    "Se ven los cobros más recientes del periodo, hasta un máximo de {tope}. Acorta las fechas para ver el resto.",
  "d.ticketNumero": "Ticket #{numero}",
  "d.imprimir": "Imprimir",
  "d.an.tituloDispensacion": "Anular dispensación #{numero}",
  "d.an.tituloVenta": "Anular venta #{numero}",
  "d.an.dispensario": "Se devolverá {cantidad} al stock.",
  "d.an.dispensarioCartera": "Se devolverá {cantidad} al stock y se reintegrarán {importe} a la cartera del socio.",
  "d.an.dispensarioCaja": "Se devolverá {cantidad} al stock y se registrará la salida de {importe} en la caja.",
  "d.an.barra": "Se devolverán las unidades al stock de la barra.",
  "d.an.barraCartera":
    "Se devolverán las unidades al stock de la barra y se reintegrarán {importe} a la cartera del socio.",
  "d.an.barraCaja":
    "Se devolverán las unidades al stock de la barra y se registrará la salida de {importe} en la caja.",
  "d.an.motivo": "Motivo de la anulación",
  "d.an.anular": "Anular",
  "d.an.fallo": "No se pudo anular",

  // --- El papel que se lleva el socio ---
  "tk.preparando": "Preparando el ticket...",
  "tk.ticket": "Ticket #{numero}",
  "tk.socio": "Socio #{numero}",
  "tk.atiende": "Atiende",
  "tk.anulada": "*** ANULADA ***",
  "tk.unidades": "{cantidad} ud x {precio}",
  "tk.gramos": "{cantidad} g x {precio}/g",
  "tk.catalogo": "{texto} · catálogo {importe}",
  "tk.total": "TOTAL",
  "tk.descuentoAplicado": "Descuento aplicado",
  "tk.descuento": "Descuento",
  "tk.descuentoCon": "Descuento {texto}",
  "tk.totalDispensado": "Total dispensado",
  "tk.formaDePago": "Forma de pago",
  "tk.saldoRestante": "Saldo restante",
  "tk.documentoInterno": "Documento interno de la asociación. No es una factura.",

  // --- El menú lateral ---
  "nav.gestionDe": "Gestión de la asociación",
  "nav.inicio": "Inicio",
  "nav.mostrador": "Mostrador",
  "nav.grupoAsociacion": "Asociación",
  "nav.donaciones": "Donaciones",
  "nav.socios": "Socios",
  "nav.caja": "Caja",
  "nav.gastos": "Gastos y compras",
  "nav.inventario": "Inventario",
  "nav.recuentos": "Recuentos",
  "nav.barra": "Barra",
  "nav.dispensaciones": "Dispensaciones",
  "nav.descuentos": "Descuentos",
  "nav.grupoAjustes": "Ajustes",
  "nav.informes": "Informes",
  "nav.ajustes": "Ajustes",
  "nav.dias": "Días",
  "nav.contrato": "Contrato",
  "nav.accesos": "Accesos",
  "nav.renovaciones": "Renovaciones",
  "nav.cuotas": "Cuotas",
  "nav.comunidad": "Comunidad",
  "nav.catalogo": "Catálogo",
  "nav.cartas": "Cartas",
  "nav.contrasena": "Contraseña",
  "rol.PROPIETARIO": "Propietario",
  "rol.TRABAJADOR": "Trabajador",
  "nav.pw.titulo": "Cambiar mi contraseña",
  "nav.pw.hecho": "Contraseña cambiada. Úsala la próxima vez que entres.",
  "nav.pw.actual": "Contraseña actual",
  "nav.pw.nueva": "Nueva contraseña",
  "nav.pw.minimo": "Mínimo 8 caracteres.",
  "nav.pw.repetir": "Repite la nueva",
  "nav.pw.noCoinciden": "No coinciden.",
  "nav.pw.cambiar": "Cambiar",
  "nav.pw.fallo": "No se pudo cambiar la contraseña",

  // --- Inicio ---
  "p.buenosDias": "Buenos días",
  "p.buenasTardes": "Buenas tardes",
  "p.buenasNoches": "Buenas noches",
  "p.saludo": "{saludo}, {nombre}",
  "p.descripcion": "Resumen de la actividad del club",
  "p.nuevaDispensacion": "Nueva dispensación",
  "p.sinCaja": "No hay ninguna caja abierta. Los cobros en efectivo no quedarán registrados en el arqueo.",
  "p.abrirCaja": "Abrir caja",
  "p.unaSolicitud": "Hay 1 solicitud de alta esperando respuesta.",
  "p.solicitudes": "Hay {n} solicitudes de alta esperando respuesta.", // siempre plural: el singular es p.unaSolicitud
  "p.verSolicitudes": "Ver solicitudes",
  "p.unaCuotaVencida": "1 socio con la cuota vencida.",
  "p.cuotasVencidas": "{n} socios con la cuota vencida.", // siempre plural: el singular es p.unaCuotaVencida
  "p.unaPorVencer": "1 cuota vence en los próximos 30 días.",
  "p.porVencer": "{n} cuotas vencen en los próximos 30 días.", // siempre plural: el singular es p.unaPorVencer
  "p.verRenovaciones": "Ver renovaciones",
  "p.pocoStockDe": "Queda poco stock de {producto}.",
  "p.bajoMinimo": "Hay {n} productos por debajo del stock mínimo.", // siempre plural: con uno se dice cuál
  "p.verInventario": "Ver inventario",
  "p.dispensadoHoy": "Dispensado hoy",
  "p.unaEntrega": "1 entrega",
  "p.entregas": "{n} entregas", // siempre plural: el singular es p.unaEntrega
  "p.unSocio": "1 socio",
  "p.socios": "{n} socios", // siempre plural: el singular es p.unSocio
  "p.entregasASocios": "{entregas} a {socios}",
  "p.aportacionesHoy": "Aportaciones hoy",
  "p.cajaAbierta": "Caja abierta",
  "p.sinCajaAbierta": "Sin caja abierta",
  "p.barraHoy": "Barra hoy",
  "p.sociosActivos": "Socios activos",
  "p.enTotal": "{n} en total",
  "p.esteMes": "Este mes",
  "p.enEntregas": "{importe} en {entregas}",
  "p.masDispensado": "Lo más dispensado hoy",
  "p.nadaHoy": "Todavía no ha salido nada hoy.",
  "p.producto": "Producto",
  "p.entregasColumna": "Entregas",
  "p.cantidad": "Cantidad",
  "p.importe": "Importe",
  "p.masBarra": "Lo más vendido en la barra hoy",
  "p.nadaBarra": "Nada de barra hoy.",
  "p.cobrosColumna": "Cobros",
  "p.unidades": "Unidades",
  "p.ultimas": "Últimas dispensaciones",
  "p.sinDispensaciones": "Todavía no hay dispensaciones registradas.",
  "p.socio": "Socio",
  "p.fecha": "Fecha",
  "p.anulada": "Anulada",
  "p.primerosPasos": "Primeros pasos",
  "p.recienCreado":
    "El club acaba de crearse. Esto es lo que conviene preparar antes de abrir el mostrador:",
  "p.paso.ajustes": "Revisa los ajustes",
  "p.paso.ajustesResto": ": límite diario y mensual por socio, cuota anual y datos de la asociación.",
  "p.paso.catalogo": "Crea las variedades",
  "p.paso.catalogoResto": " con su aportación por gramo. Ya tienes las categorías básicas creadas.",
  "p.paso.stock": "Mete el stock inicial",
  "p.paso.stockResto": " con una entrada por lote de cada variedad.",
  "p.paso.socio": "Da de alta al primer socio",
  "p.paso.socioResto": " y cóbrale la cuota.",
  "p.paso.caja": "Abre la caja",
  "p.paso.cajaResto": " al empezar el turno para que cuadre el efectivo.",
  "p.estadoSocios": "Estado de los socios",
  "p.stockBajo": "Stock bajo",

  // --- Inicio: lo que se toca en el local ---
  "il.buscarSocio": "Buscar socio",
  "il.nuevoSocio": "Nuevo socio",
  "il.dispensar": "Dispensar",
  "il.barra": "Barra",
  "il.dentroAhora": "Dentro ahora",
  "il.aforoCompleto": "Aforo completo",
  "il.hanPasadoHoy": "Han pasado hoy",
  "il.solicitudes": "Solicitudes de alta",
  "il.esperando": "esperando",
  "il.anotarGasto": "Anotar un gasto",

  // --- Inicio: primeros pasos ---
  "pp.paraEmpezar": "Para empezar",
  "pp.enEsteOrden": "En este orden es lo más rápido. Esto desaparece solo en cuanto estéis en marcha.",
  "pp.hechosDe": "{hechos} de {total}",
  "pp.ir": "Ir",
  "pasos.datos.titulo": "Completa los datos del club",
  "pasos.datos.detalle": "Nombre, CIF y dirección. Salen en los tickets y en el libro de socios.",
  "pasos.productos.titulo": "Crea tu catálogo",
  "pasos.productos.detalle": "Las categorías ya están puestas. Añade lo que dispensáis, con su aportación.",
  "pasos.stock.titulo": "Mete el stock que tienes",
  "pasos.stock.detalle": "Una entrada por lote, con proveedor y coste. De ahí sale la trazabilidad.",
  "pasos.socios.titulo": "Da de alta a los socios",
  "pasos.socios.detalle": "Uno a uno, o importando el CSV del programa que usabais antes.",
  "pasos.equipo.titulo": "Añade a tu equipo",
  "pasos.equipo.detalle": "Cada persona con su cuenta y su rol: así el registro dice quién hizo qué.",
  "pasos.caja.titulo": "Abre la caja del día",
  "pasos.caja.detalle":
    "Con el fondo inicial. Al cerrarla, el arqueo compara lo contado con lo que debería haber.",

  // --- La cinta de la suscripción ---
  "as.soloLectura": "El programa está en solo lectura.",
  "as.llevaSinRegularizar":
    "La suscripción lleva {dias} sin regularizarse. Podéis consultarlo todo y descargar las copias de seguridad desde Ajustes, pero no registrar movimientos nuevos. En cuanto se registre el pago vuelve todo al momento.",
  "as.vencioAyer": "La suscripción venció ayer.",
  "as.vencioHace": "La suscripción venció hace {dias}.",
  "as.siSigue":
    "De momento no cambia nada. Si sigue sin regularizarse, el programa pasará a solo lectura.",
  "as.venceHoy": "La suscripción vence hoy{fecha}.",
  "as.venceManana": "La suscripción vence mañana{fecha}.",
  "as.venceEn": "La suscripción vence en {dias}{fecha}.",
  "as.entreParentesis": " ({fecha})",
  "as.noHayQueHacer":
    "No hay que hacer nada aquí: la fecha se actualiza sola en cuanto se registre el pago.",

  // --- La pantalla bloqueada por inactividad ---
  "bl.explicacion":
    "La pantalla se ha bloqueado sola por no usarse. Escribe tu contraseña para seguir donde lo dejaste.",
  "bl.tuContrasena": "Tu contraseña",
  "bl.comprobando": "Comprobando...",
  "bl.continuar": "Continuar",
  "bl.salirOtraCuenta": "Salir y entrar con otra cuenta",
  "bl.fallo": "No se pudo comprobar la contraseña",

  // --- La cinta de «sin conexión» y su cola ---
  "ec.sinConexion": "Sin conexión con el servidor.",
  "ec.sinConexionDesde": "Sin conexión con el servidor desde las {hora}.",
  "ec.conPaquete":
    "El mostrador sigue funcionando con lo guardado en esta tablet: las entregas se apuntan aquí y se envían solas al volver la red.",
  "ec.sinPaquete":
    "Esta tablet no tiene guardado el catálogo: hasta que vuelva la red no se puede dispensar.",
  "ec.unaPendiente": "1 entrega pendiente de enviar.",
  "ec.pendientes": "{n} entregas pendientes de enviar.", // siempre plural: el singular es ec.unaPendiente
  "ec.unaRechazada": "1 rechazada por el servidor.",
  "ec.rechazadas": "{n} rechazadas por el servidor.",
  "ec.hayRechazada": "Hay 1 entrega que el servidor no ha aceptado: mírala.",
  "ec.hayRechazadas": "Hay {n} entregas que el servidor no ha aceptado: míralas.", // siempre plural: el singular es ec.hayRechazada
  "ec.verCola": "Ver la cola ({n})",
  "ec.enviando": "Enviando...",
  "ec.enviarAhora": "Enviar ahora",
  "ec.titulo": "Entregas guardadas en esta tablet",
  "ec.explicacion":
    "Se hicieron sin conexión y se envían solas al volver la red, en este orden. El servidor las cobra con sus importes y apunta lo que se hubiera saltado (límite, stock, saldo) como incidencia de la entrega.",
  "ec.nadaPorEnviar": "No queda nada por enviar.",
  "ec.cuando": "Cuándo",
  "ec.socio": "Socio",
  "ec.que": "Qué",
  "ec.importe": "Importe",
  "ec.estado": "Estado",
  "ec.rechazada": "Rechazada: {motivo}",
  "ec.reintentar": "Reintentar",
  "ec.descartar": "Descartar",
  "ec.confirmarDescartar": "¿Descartar esta entrega? No se registrará en ningún sitio.",
  "ec.pendienteDeEnviar": "Pendiente de enviar",
  "ec.unIntento": " (1 intento)",
  "ec.intentos": " ({n} intentos)",

  // --- De dónde viene el dinero ---
  "gi.titulo": "De dónde viene el dinero",
  "gi.dias7": "7 días",
  "gi.dias30": "30 días",
  "gi.meses12": "12 meses",
  "gi.dispensacion": "Dispensación",
  "gi.barra": "Barra",
  "gi.cuotas": "Cuotas",
  "gi.sinIngresos": "Todavía no hay ingresos registrados en este periodo.",

  // --- El tablón del equipo ---
  "tb.dejarRecadoEquipo": "Dejar un recado al equipo",
  "tb.titulo": "Tablón del equipo",
  "tb.dejarRecado": "Dejar un recado",
  "tb.ejemplo": "El género llega el jueves por la mañana...",
  "tb.fijarArriba": "Fijar arriba",
  "tb.poniendo": "Poniendo...",
  "tb.poner": "Poner",
  "tb.alguien": "Alguien",
  "tb.quitar": "Quitar del tablón",

  // --- Cobrar la cuota ---
  "dc.titulo": "Cobrar cuota a {socio}",
  "dc.cobrando": "Cobrando...",
  "dc.cobrar": "Cobrar",
  "dc.importe": "Importe (créditos)",
  "dc.periodo": "Periodo",
  "dc.unAnio": "1 año",
  "dc.dosAnios": "2 años",
  "dc.tresAnios": "3 años",
  "dc.formaDePago": "Forma de pago",
  "dc.carteraDelSocio": "Cartera del socio",
  "dc.nota": "Si aún le queda periodo, el nuevo se encadena al final; si está vencida, cuenta desde hoy.",
  "dc.fallo": "No se pudo cobrar la cuota",

  // --- Ingresar en la cartera ---
  "dr.titulo": "Ingresar en la cartera de {socio}",
  "dr.ingresar": "Ingresar {importe}",
  "dr.tieneAhora": "Tiene ahora",
  "dr.leFaltan": "Le faltan {importe} para lo que está retirando.",
  "dr.importe": "Importe (créditos)",
  "dr.formaDePago": "Forma de pago",
  "dr.entraEnCaja": "Entra en la caja del turno.",
  "dr.noTocaCaja": "No toca la caja.",
  "dr.seQuedaraCon": "Se quedará con",
  "dr.noEsIngreso": "Este dinero no es un ingreso de la asociación.",
  "dr.esDelSocio": "Es del socio hasta que se lo gaste, y puede pedirlo de vuelta.",
  "dr.confirmarTitulo": "¿Has cobrado el dinero?",
  "dr.todaviaNo": "Todavía no",
  "dr.ingresando": "Ingresando...",
  "dr.siIngresar": "Sí, ingresar",
  "dr.vasASumar": "Vas a sumar {importe} a la cartera de {socio}, que pasará a tener {total}.",
  "dr.confirmoEfectivo": "Confirmo que he cobrado {importe} en efectivo",
  "dr.confirmo": "Confirmo que he cobrado {importe}",
  "dr.siTeEquivocas":
    "Si te equivocas se puede arreglar desde la ficha del socio, devolviéndole el saldo o ajustándolo, y queda constancia de las dos cosas. Pero es mucho más fácil no equivocarse ahora.",
  "dr.fallo": "No se pudo ingresar",

  // --- Cuánto hay que devolver ---
  "cc.entregado": "Entregado",
  "cc.aCobrar": "A cobrar",
  "cc.cambio": "Cambio",
  "cc.faltan": "Faltan {importe}",
  "cc.oEscribelo": "O escríbelo",
  "cc.poner": "Poner",
  "cc.empezarDeNuevo": "Empezar de nuevo",

  // --- Firmar con el dedo ---
  "fp.firmado": "Firmado.",
  "fp.estaBien": "¿Está bien? Confírmalo.",
  "fp.firmaAqui": "Firma aquí con el dedo o el ratón.",
  "fp.repetirTitulo": "Repetir la firma",
  "fp.repetir": "Repetir",
  "fp.confirmar": "Confirmar",

  // --- Foto con la cámara ---
  "ci.sinCamara": "Este navegador no da acceso a la cámara. Sube la imagen desde el disco.",
  "ci.sinPermiso":
    "No has dado permiso para usar la cámara. Puedes darlo en el candado de la barra de direcciones.",
  "ci.sinDispositivo": "No se ha encontrado ninguna cámara. Sube la imagen desde el disco.",
  "ci.falloCamara": "No se pudo abrir la cámara. Sube la imagen desde el disco.",
  "ci.obligatoria": "Obligatoria",
  "ci.saltada": "Saltada",
  "ci.hacerFoto": "Hacer foto",
  "ci.repetir": "Repetir",
  "ci.camara": "Cámara",
  "ci.subir": "Subir",
  "ci.quitar": "Quitar",

  // --- El contrato de un socio ---
  "cs.titulo": "Contrato de socio",
  "cs.firmoEl": "Firmó la versión {numero} el {fecha}.",
  "cs.firmo": "Firmó la versión {numero}.",
  "cs.sinFirmar":
    "Sin firmar. Abajo está el de hoy (versión {numero}) con sus datos, listo para imprimir.",
  "cs.verEImprimir": "Ver e imprimir",
  "cs.apuntando": "Apuntando...",
  "cs.marcarFirmado": "Marcar como firmado",
  "cs.tambienPortal": "También puede aceptarlo él mismo desde su portal, y entonces se apunta solo.",
  "cs.verContratoClub": "Ver el contrato del club",
  "cs.modalTitulo": "Contrato · socio nº {numero}",
  "cs.noFirmadoAun": "Todavía no lo ha firmado: esto es el documento para llevárselo al mostrador.",
  "cs.firmaDelSocio": "Firma del socio",
  "cs.firmaYSello": "Firma y sello de la asociación",
  "cs.fallo": "No se pudo apuntar la firma",

  // --- Alta de socio, paso a paso ---
  "sn.titulo": "Nuevo socio",
  "sn.descripcion": "Se guarda al final: hasta entonces puedes ir y volver",
  "sn.paso.avalista": "Avalista",
  "sn.paso.datos": "Datos",
  "sn.paso.documento": "Documento",
  "sn.paso.contrato": "Contrato",
  "sn.paso.cuota": "Cuota",
  "sn.paso.repaso": "Repaso",
  "sn.falta.nombre": "Escribe el nombre",
  "sn.falta.apellidos": "Escribe los apellidos",
  "sn.falta.nacimiento": "Falta la fecha de nacimiento",
  "sn.falta.documento": "Falta el número del documento",
  "sn.falta.foto": "Falta la foto del socio",
  "sn.falta.frente": "Falta el frente del documento",
  "sn.falta.reverso": "Falta el reverso del documento, o marca que no lo tiene",
  "sn.quienAvala": "¿Quién le avala?",
  "sn.avalistaNota":
    "Muchos estatutos piden que un socio responda por el que entra. Si el vuestro no, sáltalo.",
  "sn.quitar": "Quitar",
  "sn.quienEs": "Quién es",
  "sn.nombre": "Nombre",
  "sn.apellidos": "Apellidos",
  "sn.nacimiento": "Fecha de nacimiento",
  "sn.consumo": "Consumo previsto (g/mes)",
  "sn.consumoAyuda": "Lo declara el socio; va en el contrato.",
  "sn.telefono": "Teléfono",
  "sn.email": "Email",
  "sn.dondeVive": "Dónde vive",
  "sn.direccion": "Dirección",
  "sn.ciudad": "Ciudad",
  "sn.cp": "Código postal",
  "sn.numeroSocio": "Número de socio",
  "sn.numeroAyuda": "Vacío: el siguiente que toque.",
  "sn.idioma": "Idioma",
  "sn.idiomaAyuda": "En el que ve el portal y recibe los correos de la cuota.",
  "sn.idiomaDelClub": "El del club",
  "sn.notas": "Notas internas",
  "sn.documento": "Documento de identidad",
  "sn.tipo": "Tipo",
  "sn.pasaporte": "Pasaporte",
  "sn.numero": "Número",
  "sn.fotoSocio": "Foto del socio",
  "sn.fotoSocioAyuda": "Para reconocerle en el mostrador",
  "sn.docFrente": "Documento, frente",
  "sn.docFrenteAyuda": "La cara con la foto",
  "sn.docReverso": "Documento, reverso",
  "sn.noLoTiene": "No lo tiene",
  "sn.docReversoAyuda": "La cara de detrás",
  "sn.sinReverso": "No tiene reverso",
  "sn.fotosHacenFalta":
    "Las fotos hacen falta para dar el alta: son la única forma de comprobar después que quien entró era quien decía ser. Si no tienes cámara, se pueden subir desde el disco.",
  "sn.loQueFirma": "Lo que firma",
  "sn.firma": "Firma",
  "sn.rgpd": "Ha firmado también el consentimiento de tratamiento de datos (RGPD)",
  "sn.sinFirmaSigue":
    "Sin firma el alta sigue adelante, pero el socio queda como pendiente de firmar y podrá hacerlo desde su portal.",
  "sn.cuota": "Cuota",
  "sn.cuotaNota": "Cada tipo de socio lleva su cuota, su descuento y sus límites. Se cambian en Ajustes.",
  "sn.sinTipo": "Sin tipo",
  "sn.condicionesGenerales": "Las condiciones generales del club",
  "sn.alAnio": "al año",
  "sn.alAnioLaDelClub": "al año · la del club",
  "sn.descuentoCatalogo": "−{porcentaje}% en catálogo",
  "sn.sinDescuento": "Sin descuento",
  "sn.cobrarAhora": "Cobrar ahora",
  "sn.sinCobrarla": "Sin cobrarla el socio queda pendiente y no puede retirar hasta que pague.",
  "sn.formaDePago": "Forma de pago",
  "sn.repaso": "Repaso",
  "sn.r.nombre": "Nombre",
  "sn.r.documento": "Documento",
  "sn.r.nacimiento": "Nacimiento",
  "sn.r.consumo": "Consumo declarado",
  "sn.r.gMes": "{n} g/mes",
  "sn.r.avalista": "Avalista",
  "sn.r.sinAvalista": "Sin avalista",
  "sn.r.tipo": "Tipo",
  "sn.r.rgpd": "RGPD",
  "sn.r.firmado": "Firmado",
  "sn.r.pendiente": "Pendiente",
  "sn.r.contrato": "Contrato",
  "sn.r.pendienteFirma": "Pendiente de firma",
  "sn.loQueSeCobra": "Lo que se cobra",
  "sn.cuotaAnual": "Cuota anual",
  "sn.noSeCobraNada": "No se cobra nada ahora: el socio queda pendiente.",
  "sn.nadaQueCobrar": "No hay nada que cobrar.",
  "sn.seCobraEn": "Se cobra en {forma}.",
  "sn.mini.socio": "Socio",
  "sn.mini.frente": "Frente",
  "sn.mini.reverso": "Reverso",
  "sn.mini.firma": "Firma",
  "sn.sinFoto": "Sin foto",
  "sn.atras": "Atrás",
  "sn.creando": "Creando...",
  "sn.crear": "Crear socio",
  "sn.siguiente": "Siguiente",
  "sn.fallo": "No se pudo crear el socio",
  "sn.avisoSubida": "El socio está creado, pero no se pudo subir {que}.",
  "sn.subida.foto": "la foto del socio",
  "sn.subida.frente": "el frente del documento",
  "sn.subida.reverso": "el reverso del documento",
  "sn.subida.firma": "la firma",
  "sn.seAsigna": "(se asigna al crear)",

  // --- Editar un socio ---
  "se.titulo": "Editar a {socio}",
  "se.descripcion": "Socio número {numero}",
  "se.guardarCambios": "Guardar cambios",
  "se.datosPersonales": "Datos personales",
  "se.nombre": "Nombre *",
  "se.apellidos": "Apellidos *",
  "se.tipoDocumento": "Tipo de documento",
  "se.numero": "Número *",
  "se.nacimiento": "Fecha de nacimiento *",
  "se.limitesPropios": "Límites propios",
  "se.sinLimites": "Si los dejas vacíos se aplican los del club.",
  "se.sinLimitesConCifras": "Si los dejas vacíos se aplican los del club ({diario} g al día, {mensual} g al mes).",
  "se.limiteDiario": "Límite diario (g)",
  "se.limiteMensual": "Límite mensual (g)",
  "se.delClub": "Club: {cantidad}",
  "se.asociacion": "Asociación",
  "se.tipoDeSocio": "Tipo de socio",
  "se.sinTipo": "Sin tipo (condiciones del club)",
  "se.avalista": "Socio avalista",
  "se.buscarAvalista": "Buscar avalista...",
  "se.rgpd": "Consentimiento de tratamiento de datos (RGPD) firmado",
  "se.fallo": "No se pudieron guardar los cambios",

  // --- El libro de socios, para imprimir ---
  "lb.volver": "Volver a socios",
  "lb.imprimir": "Imprimir o guardar en PDF",
  "lb.comoPdf":
    "Al imprimir sale solo el documento, sin los menús. Para guardarlo como PDF, elige «Guardar como PDF» en el destino de la impresora.",
  "lb.titulo": "Libro de socios",
  "lb.emision": "Extracto emitido el {fecha} por {quien}.",
  "lb.numero": "Nº",
  "lb.apellidosNombre": "Apellidos y nombre",
  "lb.documento": "Documento",
  "lb.nacimiento": "Nacimiento",
  "lb.alta": "Alta",
  "lb.baja": "Baja",
  "lb.avalista": "Avalista",
  "lb.rgpd": "RGPD",
  "lb.estado": "Estado",
  "lb.numeroAvalista": "nº {numero}",
  "lb.si": "Sí",
  "lb.sinSocios": "El registro no tiene todavía ningún socio inscrito.",
  "lb.unInscrito": "1 socio inscrito",
  "lb.inscritos": "{n} socios inscritos", // siempre plural: el singular es lb.unInscrito
  "lb.enTotal": "en total: {reparto}.",
  "lb.enAlta": "{n} en alta",
  "lb.suspendidos": "{n} suspendidos",
  "lb.pendientes": "{n} pendientes de alta",
  "lb.bajas": "{n} de baja",
  "lb.consentimiento": "Con consentimiento de tratamiento de datos firmado: {conConsentimiento} de {total}.",
  "lb.consumoDeclarado":
    "Consumo declarado por los socios en alta: {alMes} al mes, que son {alAnio} al año. Es lo que declararon necesitar al darse de alta.",
  "lb.notaPie":
    "Documento interno de la asociación, emitido a partir de su registro de socios en la fecha indicada.",

  // --- Los carnets ---
  "cn.preparando": "Preparando los carnets...",
  "cn.falloPreparar": "No se pudieron preparar los carnets.",
  "cn.volver": "Volver",
  "cn.unCarnet": "1 carnet",
  "cn.carnets": "{n} carnets",
  "cn.cuantos": "{carnets}, a tamaño de tarjeta: ocho por hoja A4.",
  "cn.cuantosTodos": "{carnets} (todos los socios activos), a tamaño de tarjeta: ocho por hoja A4.",
  "cn.comoImprimir":
    "Al imprimir sale solo la hoja de carnets, sin los menús; para guardarla en PDF, elige «Guardar como PDF» en el destino de la impresora.",
  "cn.elQr": "El QR es el mismo que el del portal del socio: el mostrador lo lee igual.",
  "cn.ninguno": "No hay ningún socio que imprimir.",
  "cn.numero": "Nº {numero}",
  "cn.validoHasta": "Válido hasta {fecha}",
  "cn.socioDesde": "Socio desde {fecha}",
  "cn.documentoInterno": "Documento interno de la asociación",

  // --- Importar socios de un CSV ---
  "si.titulo": "Importar socios",
  "si.descripcion": "Trae el registro de socios desde otro programa o desde una hoja de cálculo",
  "si.volver": "Volver",
  "si.importadoUno": "Importado 1 socio. Ya aparece en el registro.",
  "si.importados": "Importados {n} socios. Ya aparecen en el registro.", // siempre plural: el singular es si.importadoUno
  "si.verSocios": "Ver socios",
  "si.otroFichero": "Importar otro fichero",
  "si.paso1": "1. Prepara el fichero",
  "si.explicacion":
    "Un CSV con una fila por socio. Se necesitan al menos «Nombre», «Apellidos», «Documento» y «Fecha nacimiento», en castellano o en catalán. Si hay columna «Número» se respeta el número de socio de siempre; si no, se asignan los siguientes libres. El resto (teléfono, email, dirección, estado, fecha de alta, cuota hasta, notas) se usa si está. Sirve el fichero que exporta este mismo programa.",
  "si.explicacionNombreEntero":
    "Si el nombre y los apellidos vienen juntos en una sola columna («Nombre y apellidos», «Nombre completo»), los separo yo y te enseño el reparto antes de guardar nada.",
  "si.explicacionColumnasDobles":
    "Y si vienen al revés, repartidos en dos columnas («Primer apellido» y «Segundo apellido», o «Primer nombre» y «Segundo nombre»), los junto.",
  "si.direccion": "Dirección",
  "si.direccionJuntada":
    "La dirección venía repartida en varias columnas («Calle», «Número», «Piso»…) y la he juntado en una línea, poniendo delante de cada trozo la palabra que usa tu fichero. Aquí la ves entera.",
  "si.numeroEnLaCalle":
    "Atención con la columna «Número»: como el fichero trae la dirección repartida, la he leído como el número de la calle y no como el número de socio. Los números de socio se reparten a partir del siguiente libre. Si esa columna eran tus números de socio, ponle otro nombre a la del portal («Número calle») y vuelve a subirlo.",
  "si.explicacionVarios":
    "Cuando hay varias columnas para lo mismo («Teléfono 1» y «Teléfono 2»), me quedo con la primera: del socio se guarda un teléfono, no tres.",
  "si.explicacionDireccion":
    "La dirección puede venir partida en «Calle», «Número», «Piso» y «Puerta», y el DNI en número y letra: los junto yo.",
  "si.formatos":
    "Fechas en formato 2026-09-01 o 01/09/2026. Separador «;» o «,». Se aceptan ficheros guardados por Excel en cualquiera de sus codificaciones.",
  "si.descargarPlantilla": "Descargar plantilla",
  "si.falloPlantilla": "No se pudo descargar la plantilla",
  "si.paso2": "2. Elige el fichero y analízalo",
  "si.analizarNoGuarda": "Analizar no guarda nada: solo comprueba el fichero y te dice qué encuentra.",
  "si.analizando": "Analizando...",
  "si.analizar": "Analizar",
  "si.paso3": "3. Resultado",
  "si.procesando": "Procesando el fichero...",
  "si.eligeFichero": "Elige un fichero y pulsa Analizar.",
  "si.filas": "Filas",
  "si.validas": "Válidas",
  "si.conErrores": "Con errores",
  "si.columnas": "Columnas reconocidas: {columnas}",
  "si.corrige":
    "Corrige estas filas en el fichero y vuelve a analizarlo. No se importa nada mientras haya errores.",
  "si.fila": "Fila",
  "si.problema": "Problema",
  "si.numero": "Nº",
  "si.socio": "Socio",
  "si.nombre": "Nombre",
  "si.apellidos": "Apellidos",
  "si.columnasJuntadas":
    "El fichero trae el apellido (o el nombre) repartido en dos columnas y las he juntado en una. Aquí no hay nada que adivinar, sale tal cual venía; échale un ojo de todas formas para confirmar que es el orden que esperabas.",
  "si.nombrePartido":
    "El fichero trae el nombre y los apellidos en la misma columna y los he separado. No se pierde ningún trozo del nombre, pero dónde acaba el nombre y empiezan los apellidos es una suposición mía. Repásalo aquí antes de importar: si alguno ha quedado mal repartido, se arregla editando el socio.",
  "si.documento": "Documento",
  "si.estado": "Estado",
  "si.seMuestran": "Se muestran {cuantos} de {total}.",
  "si.importarUno": "Importar 1 socio",
  "si.importarVarios": "Importar {n} socios", // siempre plural: el singular es si.importarUno
  "si.falloLeer": "No se pudo leer el fichero",
  "si.falloImportar": "No se pudo importar",

  // --- La ficha de un socio ---
  "sf.volver": "Volver",
  "sf.carnet": "Carnet",
  "sf.editar": "Editar ficha",
  "sf.dispensar": "Dispensar",
  "sf.unAnio": "1 año",
  "sf.anios": "{n} años",
  "sf.subiendo": "Subiendo...",
  "sf.cambiarFoto": "Cambiar foto",
  "sf.anadirFoto": "Añadir foto",
  "sf.quitarFoto": "Quitar foto",
  "sf.falloQuitarFoto": "No se pudo quitar la foto",
  "sf.documento": "Documento",
  "sf.alta": "Alta",
  "sf.cuotaHasta": "Cuota hasta",
  "sf.avalista": "Avalista",
  "sf.rgpd": "Consentimiento RGPD",
  "sf.portal": "Portal del socio",
  "sf.activo": "Activo",
  "sf.sinAcceso": "Sin acceso",
  "sf.cartera": "Cartera",
  "sf.recargar": "Recargar",
  "sf.cobrarCuota": "Cobrar cuota",
  "sf.devolverSaldo": "Devolver saldo",
  "sf.ajustarSaldo": "Ajustar saldo",
  "sf.suspender": "Suspender temporalmente",
  "sf.levantar": "Levantar suspensión",
  "sf.falloLevantar": "No se pudo levantar",
  "sf.reactivar": "Reactivar socio",
  "sf.falloReactivar": "No se pudo reactivar",
  "sf.renovarPortal": "Renovar acceso al portal",
  "sf.darPortal": "Dar acceso al portal",
  "sf.falloCodigo": "No se pudo generar el código",
  "sf.retirarPortal": "Retirar acceso al portal",
  "sf.falloRetirar": "No se pudo retirar el acceso",
  "sf.darDeBaja": "Dar de baja",
  "sf.descargarDatos": "Descargar sus datos",
  "sf.falloDescargar": "No se pudieron descargar los datos",
  "sf.borrarDatos": "Borrar sus datos",
  "sf.consumoYLimites": "Consumo y límites",
  "sf.hoy": "Hoy",
  "sf.esteMes": "Este mes",
  "sf.puedeRetirar": "Puede retirar ahora",
  "sf.consumoDeclarado": "Consumo declarado en el alta",
  "sf.alMes": "{cantidad}/mes",
  "sf.tab.resumen": "Resumen",
  "sf.tab.dispensaciones": "Dispensaciones",
  "sf.tab.cartera": "Movimientos",
  "sf.tab.cuotas": "Cuotas",
  "sf.entregasRegistradas": "Entregas registradas",
  "sf.ultimaVisita": "Última visita",
  "sf.cuotasPagadas": "Cuotas pagadas",
  "sf.notas": "Notas internas",
  "sf.avalados": "Socios avalados",
  "sf.sinDispensaciones": "Este socio todavía no ha retirado producto.",
  "sf.fecha": "Fecha",
  "sf.productos": "Productos",
  "sf.cantidad": "Cantidad",
  "sf.importe": "Importe",
  "sf.anulada": "Anulada",
  "sf.sinCartera": "Sin movimientos de cartera.",
  "sf.concepto": "Concepto",
  "sf.saldo": "Saldo",
  "sf.sinCuotas": "Sin cuotas registradas.",
  "sf.validaHasta": "Válida hasta",
  "sf.codigoPortal": "Código para el portal del socio",
  "sf.hecho": "Hecho",
  "sf.daleLosDatos": "Dale estos datos al socio. El código caduca en 7 días y solo sirve una vez.",
  "sf.numeroDeSocio": "Número de socio",
  "sf.codigo": "Código",
  "sf.entraEn": "Entra en {url} y elige «Activar mi acceso».",
  "sf.devolverTitulo": "Devolver saldo al socio",
  "sf.devolverEtiqueta": "Importe a devolver",
  "sf.ajustarTitulo": "Ajustar saldo",
  "sf.ajustarEtiqueta": "Importe del ajuste (negativo para restar)",
  "sf.bajaTitulo": "Dar de baja al socio",
  "sf.bajaTexto":
    "El socio dejará de poder retirar producto. El historial se conserva. Si tiene saldo en la cartera hay que devolverlo antes.",
  "sf.suspenderTitulo": "Suspender temporalmente",
  "sf.suspenderTexto":
    "Mientras esté suspendido no podrá entrar ni retirar producto. Se levanta desde esta misma ficha.",
  "sf.suspenderBoton": "Suspender",
  "sf.comoMaximo": "Como máximo {importe} créditos.",
  "sf.confirmar": "Confirmar",
  "sf.motivoObligatorio": "Motivo (obligatorio)",
  "sf.motivo": "Motivo",
  "sf.formaDePago": "Forma de pago",
  "sf.falloAccion": "No se pudo completar la acción",
  "sf.borrarTitulo": "Borrar los datos del socio",
  "sf.borrando": "Borrando...",
  "sf.sinVuelta": "Esto no tiene vuelta atrás.",
  "sf.seBorra": "Se borra:",
  "sf.seBorraLista":
    "nombre, apellidos, documento, fecha de nacimiento, teléfono, correo, dirección, foto, notas y su acceso al portal.",
  "sf.seConserva": "Se conserva:",
  "sf.seConservaLista":
    "el número de socio y sus dispensaciones, cuotas, movimientos de cartera y accesos. Son la contabilidad y la trazabilidad del club, y borrarlos dejaría el libro descuadrado y el rastro de los lotes roto. Quedan sin nombre detrás.",
  "sf.copiasDeSeguridad":
    "Las copias de seguridad hechas antes de hoy siguen teniendo sus datos: se irán cuando caduquen. Si en vuestro caso hace falta ir más allá, consultadlo con vuestro asesor.",
  "sf.escribeNumero": "Escribe el número de socio ({numero}) para confirmar",
  "sf.falloBorrar": "No se pudieron borrar los datos",
  "sf.frente": "Frente",
  "sf.reverso": "Reverso",
  "sf.sinFoto": "Sin foto",
  "sf.cambiar": "Cambiar",
  "sf.subir": "Subir",

  // --- Cuotas cobradas y tipos de socio ---
  "cu.titulo": "Cuotas",
  "cu.descripcion": "Lo que se ha cobrado de cuotas, y los tipos de socio que hay",
  "cu.a": "a",
  "cu.exportar": "Exportar CSV",
  "cu.falloExportar": "No se pudo exportar",
  "cu.tabCobradas": "Cobradas",
  "cu.tabTipos": "Tipos de socio",
  "cu.cobradoEnPeriodo": "Cobrado en el periodo",
  "cu.unaCuota": "1 cuota",
  "cu.cuotas": "{n} cuotas", // siempre plural: el singular es cu.unaCuota
  "cu.altas": "Altas",
  "cu.altasPie": "Primeras cuotas: socios nuevos",
  "cu.enEfectivo": "En efectivo",
  "cu.enEfectivoPie": "Entra en la caja del turno",
  "cu.buscar": "Buscar por socio, DNI o concepto",
  "cu.altasYRenovaciones": "Altas y renovaciones",
  "cu.soloAltas": "Solo altas",
  "cu.soloRenovaciones": "Solo renovaciones",
  "cu.cualquierTipo": "Cualquier tipo de socio",
  "cu.cualquierForma": "Cualquier forma de pago",
  "cu.cualquierPuesto": "Cualquier puesto",
  "cu.sinCoincidencias": "Ninguna cuota cobrada con estos filtros. Para ver a quién le toca pagar,",
  "cu.miraRenovaciones": "mira Renovaciones",
  "cu.fecha": "Fecha",
  "cu.socio": "Socio",
  "cu.tipoDeSocio": "Tipo de socio",
  "cu.altaORenovacion": "Alta o renovación",
  "cu.periodo": "Periodo",
  "cu.forma": "Forma",
  "cu.puesto": "Puesto",
  "cu.cobro": "Cobró",

  "cu.an.boton": "Anular",
  "cu.an.anulada": "Anulada",
  "cu.an.titulo": "Anular una cuota de {importe}",
  "cu.an.queVaAPasar":
    "Se le devuelven {importe} a {socio} y su cuota deja de contar: la fecha hasta la que está al día vuelve a la de su cuota anterior, y si esta era la única no podrá retirar nada hasta que pague otra.",
  "cu.an.deLaCartera": "Como la pagó de su cartera, el saldo le vuelve en el acto.",
  "cu.an.delCajon":
    "Como la pagó en efectivo, el dinero sale del cajón en el que entró. Si ese turno ya se cerró no se toca ninguna caja: su arqueo ya se firmó con esta cuota dentro.",
  "cu.an.motivo": "Motivo",
  "cu.an.motivoAyuda":
    "Queda apuntado. Dentro de seis meses es lo único que explicará esta anulación.",
  "cu.an.confirmar": "Anular la cuota",
  "cu.an.anulando": "Anulando…",
  "cu.an.fallo": "No se pudo anular la cuota",
  "cu.importe": "Importe",
  "cu.alta": "Alta",
  "cu.renovacion": "Renovación",
  "cu.tiposTitulo": "Tipos de socio",
  "cu.tiposNota": "Cada tipo lleva su cuota, cuánto dura, su descuento y sus límites.",
  "cu.seEditanEnAjustes": "Se crean y se editan en Ajustes",
  "cu.sinTipos": "Sin tipos de socio. Todos pagan la cuota general del club.",
  "cu.sinTiposConCuota": "Sin tipos de socio. Todos pagan la cuota general del club, {importe} al año.",
  "cu.tipo": "Tipo",
  "cu.cuota": "Cuota",
  "cu.dura": "Dura",
  "cu.descuento": "Descuento",
  "cu.socios": "Socios",
  "cu.apagado": " · apagado",
  "cu.laDelClub": "la del club",
  "cu.unAnio": "1 año",
  "cu.anios": "{n} años",
  "cu.unMes": "1 mes",
  "cu.meses": "{n} meses",

  // --- Renovaciones ---
  "rn.titulo": "Renovaciones",
  "rn.descripcion": "Socios con la cuota vencida o a punto de vencer",
  "rn.vencenEnDias": "Vencen en {dias}",
  "rn.cuotaVencida": "Cuota vencida",
  "rn.noPuedenRetirar": "No pueden retirar producto",
  "rn.convieneAvisar": "Conviene avisarles",
  "rn.cuotaAnual": "Cuota anual",
  "rn.nadieVencida": "Nadie tiene la cuota vencida.",
  "rn.vencenEnLosProximos": "Vencen en los próximos {dias}",
  "rn.ningunaVence": "Ninguna cuota vence en los próximos {dias}.",
  "rn.laAsociacion": "la asociación",
  "rn.cobrada": "Cuota de {socio} cobrada. Válida hasta {fecha}.",
  "rn.socio": "Socio",
  "rn.telefono": "Teléfono",
  "rn.estado": "Estado",
  "rn.cuotaHasta": "Cuota hasta",
  "rn.whatsapp": "WhatsApp",
  "rn.mensajeWhatsapp":
    "Hola {nombre}, te escribimos de {club}. Tu cuota de socio está pendiente de renovar. Pásate cuando puedas por el local. Gracias.",
  "rn.sinCuota": "Sin cuota",
  "rn.vencioHace": "venció hace {dias}",
  "rn.venceHoy": "vence hoy",
  "rn.queda": "queda {dias}",
  "rn.quedan": "quedan {dias}",
  "rn.cobrarCuota": "Cobrar cuota",
  "rn.nadieAQuienAvisar": "No había a quien avisar: o ya se les avisó de esta cuota, o no vence todavía.",
  "rn.avisadoUno": "Avisado 1 socio ({porCorreo} por correo, {porMovil} al móvil).",
  "rn.avisados": "Avisados {n} socios ({porCorreo} por correo, {porMovil} al móvil).", // siempre plural: el singular es rn.avisadoUno
  "rn.unoSinCorreo": "1 socio sin correo en la ficha.",
  "rn.sinCorreo": "{n} socios sin correo en la ficha.", // siempre plural: el singular es rn.unoSinCorreo
  "rn.falloRecordatorios": "No se pudieron enviar los recordatorios",
  "rn.enviando": "Enviando...",
  "rn.avisar": "Avisar a los que vencen",

  // --- Gastos y compras: las pestañas ---
  "gc.gastos": "Gastos",
  "gc.compras": "Compras",
  "gc.proveedores": "Proveedores",

  "pago.DOMICILIADO": "Domiciliado",

  // --- Gastos ---
  "ga.titulo": "Gastos y compras",
  "ga.descripcion": "Lo que sale de la asociación, con su categoría",
  "ga.a": "a",
  "ga.categorias": "Categorías",
  "ga.exportar": "Exportar CSV",
  "ga.falloExportar": "No se pudo exportar",
  "ga.nuevo": "+ Gasto",
  "ga.totalFiltrado": "Total de lo filtrado",
  "ga.totalPeriodo": "Total del periodo",
  "ga.unApunte": "1 apunte",
  "ga.apuntes": "{n} apuntes", // siempre plural: el singular es ga.unApunte
  "ga.enEfectivo": "En efectivo",
  "ga.saleDeCaja": "Sale de la caja del día",
  "ga.categoriaMayor": "Categoría mayor",
  "ga.porCategoria": "Por categoría",
  "ga.sinGastos": "Sin gastos en este periodo.",
  "ga.gastosDe": "Gastos de {categoria}",
  "ga.todosLosGastos": "Todos los gastos",
  "ga.buscar": "Buscar por concepto, proveedor o nota",
  "ga.todasCategorias": "Todas las categorías",
  "ga.apagada": " (apagada)",
  "ga.cualquierForma": "Cualquier forma de pago",
  "ga.cualquierPuesto": "Cualquier puesto",
  "ga.conPagosProveedor": "Con los pagos a proveedor",
  "ga.verAnulados": "Ver los anulados",
  "ga.sinCoincidencias": "Ningún gasto con esos filtros.",
  "ga.sinApuntes": "No hay gastos anotados en este periodo.",
  "ga.numero": "Nº",
  "ga.fecha": "Fecha",
  "ga.concepto": "Concepto",
  "ga.categoria": "Categoría",
  "ga.pago": "Pago",
  "ga.puesto": "Puesto",
  "ga.importe": "Importe",
  "ga.compraNumero": " · Compra #{numero}",
  "ga.anulado": "Anulado",
  "ga.anuladoPor": "Anulado: {motivo}",
  "ga.editar": "Editar",
  "ga.anular": "Anular",
  "ga.d.editar": "Editar gasto",
  "ga.d.nuevo": "Nuevo gasto",
  "ga.d.fallo": "No se pudo guardar el gasto",
  "ga.d.concepto": "Concepto",
  "ga.d.conceptoEjemplo": "Factura de la luz",
  "ga.d.importe": "Importe (créditos)",
  "ga.d.fecha": "Fecha",
  "ga.d.categoria": "Categoría",
  "ga.d.formaDePago": "Forma de pago",
  "ga.d.saldraDeCaja": "Saldrá de la caja abierta.",
  "ga.d.proveedor": "Proveedor",
  "ga.d.notas": "Notas",
  "ga.d.editarNota":
    "Editar un gasto no cambia el movimiento de caja que se anotó en su día: el arqueo de aquel turno ya está cerrado.",
  "ga.an.titulo": "Anular el gasto #{numero}",
  "ga.an.fallo": "No se pudo anular",
  "ga.an.motivo": "Motivo",
  "ga.an.motivoAyuda": "Queda apuntado junto al gasto, para que se entienda al revisar el mes.",
  "ga.an.motivoEjemplo": "Estaba mal el importe",
  "ga.an.noSeBorra": "No se borra: se queda tachado en la lista.",
  "ga.an.vuelveALaCaja": " El dinero vuelve a la caja abierta.",
  "ga.an.compraNoPagada": " La compra #{numero} volverá a figurar como no pagada.",
  "ga.c.titulo": "Categorías de gasto",
  "ga.c.listo": "Listo",
  "ga.c.fallo": "No se pudo",
  "ga.c.ejemplo": "Agua, Nóminas, Asesoría...",
  "ga.c.anadir": "Añadir",
  "ga.c.unGasto": "1 gasto",
  "ga.c.gastos": "{n} gastos", // siempre plural: el singular es ga.c.unGasto
  "ga.c.apagadaNota": "Apagada · no se ofrece al anotar",
  "ga.c.seApagara": "Se apagará: tiene gastos dentro",
  "ga.c.quitarla": "Quitarla",
  "ga.c.quitar": "Quitar",
  "ga.c.volverAUsar": "Volver a usar",
  "ga.c.nota":
    "Una categoría con gastos dentro se apaga en vez de borrarse: así los apuntes de años anteriores siguen diciendo de qué eran.",

  // --- Compras y proveedores ---
  "co.titulo": "Gastos y compras",
  "co.descripcion": "Pedidos a proveedor, lo que llega y lo que se debe",
  "co.nuevaCompra": "+ Compra",
  "co.nuevoProveedor": "+ Proveedor",
  "co.antesDeLaPrimera":
    "Antes de la primera compra hay que dar de alta al proveedor, para que deje de ser un nombre suelto y se pueda ver qué ha traído y qué se le debe.",
  "co.pendienteDePagar": "Pendiente de pagar",
  "co.aTodos": "A todos los proveedores",
  "co.pedidasSinRecibir": "Pedidas sin recibir",
  "co.enCamino": "Encargadas y todavía en camino",
  "co.sinProveedores": "Todavía no hay proveedores.",
  "co.proveedor": "Proveedor",
  "co.contacto": "Contacto",
  "co.compras": "Compras",
  "co.seLeDebe": "Se le debe",
  "co.sinCompras":
    "Todavía no hay compras. Al recibir una, su género entra solo en el almacén con su coste y su proveedor, sin volver a teclearlo en Inventario.",
  "co.pedida": "Pedida",
  "co.recibida": "Recibida",
  "co.anulada": "Anulada",
  "co.debe": "Debe {importe}",
  "co.pagada": "Pagada",
  "co.recibidaEl": " · recibida el {fecha}",
  "co.noEsGenero": " · no es género",
  "co.haLlegado": "Ha llegado",
  // Anular una compra que se pidio y no ha llegado. El motivo es opcional:
  // no se deshace nada, al contrario que al anular una entrega.
  "co.anular": "Anular",
  "co.an.titulo": "Anular la compra #{numero}",
  "co.an.quePasa":
    "La compra queda anulada y deja de contar en lo que se le debe al proveedor. El stock no se toca: aún no había llegado.",
  "co.an.motivo": "Motivo (opcional)",
  "co.an.confirmar": "Anular la compra",
  "co.an.fallo": "No se pudo anular la compra",
  "co.an.hecho": "Compra #{numero} anulada",
  "co.pagar": "Pagar",
  "co.recibidaConLotes": "Compra #{numero} recibida. {lotes} en el almacén.",
  "co.recibidaSinLotes": "Compra #{numero} recibida.",
  "co.unLote": "1 lote",
  "co.lotes": "{n} lotes", // siempre plural: el singular es co.unLote
  "co.falloRecibir": "No se pudo recibir",
  "co.p.titulo": "Nuevo proveedor",
  "co.p.fallo": "No se pudo guardar",
  "co.p.nombre": "Nombre",
  "co.p.cif": "CIF o NIF",
  "co.p.telefono": "Teléfono",
  "co.p.email": "Email",
  "co.p.notas": "Notas",
  "co.n.titulo": "Nueva compra",
  "co.n.fallo": "No se pudo guardar la compra",
  "co.n.registrar": "Registrar · {importe}",
  "co.n.proveedor": "Proveedor",
  "co.n.referencia": "Albarán o factura",
  "co.n.referenciaAyuda": "Opcional, el número que trae el papel.",
  "co.n.queSeCompra": "Qué se compra",
  "co.n.explicacion":
    "Las líneas que apuntan a un producto del catálogo generan su lote al recibir la compra. Las demás —botes, etiquetas, una balanza— son gasto y no tocan las existencias.",
  "co.n.producto": "Producto",
  "co.n.noEsGenero": "No es género",
  "co.n.descripcion": "Descripción",
  "co.n.gramos": "Gramos",
  "co.n.coste": "Coste (créditos)",
  "co.n.otraLinea": "+ Otra línea",
  "co.n.quitarUltima": "Quitar la última",
  "co.g.titulo": "Pagar la compra #{numero}",
  "co.g.fallo": "No se pudo registrar el pago",
  "co.g.registrar": "Registrar el pago",
  "co.g.quedanPorPagar": "De esta compra quedan {importe} por pagar a {proveedor}.",
  "co.g.importe": "Importe (créditos)",
  "co.g.aPlazos": "Se puede pagar a plazos.",
  "co.g.formaDePago": "Forma de pago",
  "co.g.comoGasto":
    "El pago se apunta como gasto atado a esta compra, para que el dinero salga una sola vez en las cuentas.",
  "co.g.enEfectivo": "En efectivo, sale de la caja del turno.",

  // --- Donaciones e ingresos en cartera ---
  "do.titulo": "Donaciones e ingresos",
  "do.descripcion": "Lo que dan al club y lo que la gente mete en su cartera para gastar dentro",
  "do.a": "a",
  "do.exportar": "Exportar CSV",
  "do.falloExportar": "No se pudo exportar",
  "do.nueva": "+ Donación",
  "do.tabDonaciones": "Donaciones",
  "do.tabCartera": "Ingresos en cartera",
  "do.deSuCartera": "De su cartera",
  "do.donadoEnPeriodo": "Donado en el periodo",
  "do.unaDonacion": "1 donación",
  "do.donaciones": "{n} donaciones",
  "do.sinNombre": "Sin nombre",
  "do.delBote": "Del bote, sin socio detrás",
  "do.enEfectivo": "En efectivo",
  "do.entraEnCaja": "Entra en la caja del turno",
  "do.ingresadoEnPeriodo": "Ingresado en el periodo",
  "do.unIngreso": "1 ingreso",
  "do.ingresos": "{n} ingresos",
  "do.clubDebe": "El club debe ahora",
  "do.saldoVivo": "Saldo vivo en todas las carteras",
  "do.buscar": "Buscar por socio o concepto",
  "do.cualquierForma": "Cualquier forma de pago",
  "do.cualquierPuesto": "Cualquier puesto",
  "do.verAnuladas": "Ver las anuladas",
  "do.sinDonaciones":
    "Ninguna donación con estos filtros. Sirven para apuntar el dinero que alguien da al club sin que sea su cuota ni lo que se lleva.",
  "do.numero": "Nº",
  "do.fecha": "Fecha",
  "do.quien": "Quién",
  "do.concepto": "Concepto",
  "do.forma": "Forma",
  "do.puesto": "Puesto",
  "do.atendio": "Atendió",
  "do.importe": "Importe",
  "do.anonima": "Anónima",
  "do.anulada": "Anulada",
  "do.anular": "Anular",
  "do.sinIngresos":
    "Nadie ha metido dinero en su cartera con estos filtros. Los ingresos se hacen desde la ficha del socio o desde el mostrador.",
  "do.socio": "Socio",
  "do.loCobro": "Lo cobró",
  "do.ingresado": "Ingresado",
  "do.saldoDespues": "Saldo después",
  "do.sinDato": "Sin dato",
  "do.r.titulo": "Registrar una donación",
  "do.r.fallo": "No se pudo registrar la donación",
  "do.r.registrar": "Registrar",
  "do.r.quienDona": "Quién dona",
  "do.r.quienDonaAyuda": "Se puede dejar en blanco: hay quien deja dinero en el bote sin dar su nombre.",
  "do.r.quitar": "Quitar",
  "do.r.buscarSocio": "Buscar socio, o dejarlo en blanco",
  "do.r.importe": "Importe (créditos)",
  "do.r.formaDePago": "Forma de pago",
  "do.r.faltaSocio": "Para donar desde la cartera hay que decir de qué socio.",
  "do.r.efectivoNota": "Entra en la caja del turno. Las demás formas no la tocan.",
  "do.r.concepto": "Concepto",
  "do.r.conceptoAyuda": "Opcional. Por ejemplo: bote de la barra, rifa, aportación extra.",
  "do.an.titulo": "Anular la donación",
  "do.an.fallo": "No se pudo anular",
  "do.an.anulando": "Anulando...",
  "do.an.anular": "Anular",
  "do.an.explicacion":
    "Se anulan {importe}. La donación no se borra: se marca como anulada y deja de contar en las cuentas. Un ingreso que desaparece del historial es un agujero en el arqueo.",
  "do.an.efectivo": "El dinero sale de la caja abierta con su propio apunte.",
  "do.an.cartera": "Se le devuelve el saldo al socio.",
  "do.an.motivo": "Motivo",
  "do.an.motivoAyuda": "Opcional, pero ayuda a entenderlo dentro de seis meses.",

  // --- Los días de la semana, cortos y enteros ---
  "semana.1c": "L",
  "semana.2c": "M",
  "semana.3c": "X",
  "semana.4c": "J",
  "semana.5c": "V",
  "semana.6c": "S",
  "semana.0c": "D",
  "semana.1": "Lunes",
  "semana.2": "Martes",
  "semana.3": "Miércoles",
  "semana.4": "Jueves",
  "semana.5": "Viernes",
  "semana.6": "Sábado",
  "semana.0": "Domingo",

  // --- Descuentos de campaña ---
  "de.titulo": "Descuentos",
  "de.descripcion": "Campañas por categoría, producto, tipo de socio, día y franja horaria",
  "de.nuevo": "+ Descuento",
  "de.unoSolo": "un solo descuento, el mayor",
  "de.noSeAcumulan":
    "que encaje: no se acumulan entre sí ni con el descuento general del tipo de socio.",
  "de.enCadaEntrega": "En cada entrega se aplica",
  "de.sinDescuentos": "No hay descuentos. Crea uno para, por ejemplo, una tarde de flores al 15%.",
  "de.nombre": "Nombre",
  "de.descuento": "Descuento",
  "de.aplicaA": "Aplica a",
  "de.cuando": "Cuándo",
  "de.estado": "Estado",
  "de.categoriaNombre": "Categoría {nombre}",
  "de.todoElCatalogo": "Todo el catálogo",
  "de.soloTipo": "Solo {tipo}",
  "de.todosLosDias": "Todos los días",
  "de.activo": "Activo",
  "de.apagado": "Apagado",
  "de.editar": "Editar",
  "de.borrar": "Borrar",
  "de.falloBorrar": "No se pudo borrar",
  "de.d.editar": "Editar {nombre}",
  "de.d.nuevo": "Nuevo descuento",
  "de.d.fallo": "No se pudo guardar el descuento",
  "de.d.nombre": "Nombre",
  "de.d.nombreAyuda": "Sale en el ticket, p. ej. «Tarde tranquila».",
  "de.d.porcentaje": "Descuento (%)",
  "de.d.categoria": "Categoría",
  "de.d.categoriaAyuda": "Vacío = todas.",
  "de.d.todas": "Todas",
  "de.d.producto": "Producto concreto",
  "de.d.productoAyuda": "Vacío = todos los de la categoría.",
  "de.d.todos": "Todos",
  "de.d.tipoSocio": "Solo para un tipo de socio",
  "de.d.tipoSocioAyuda": "Vacío = para todos.",
  "de.d.todosLosSocios": "Todos los socios",
  "de.d.dias": "Días de la semana",
  "de.d.diasAyuda": "Ninguno marcado = todos los días.",
  "de.d.desdeLas": "Desde las",
  "de.d.franjaAyuda": "Franja horaria; vacío = todo el día.",
  "de.d.hastaLas": "Hasta las",
  "de.d.fechaInicio": "Fecha de inicio",
  "de.d.fechaAyuda": "Vacío = sin límite.",
  "de.d.fechaFin": "Fecha de fin",
  "de.d.activo": "Activo",

  // --- Las cartas del local ---
  "ca.titulo": "Cartas",
  "ca.descripcion": "Lo que ven los socios en la pantalla del local o al escanear un QR",
  "ca.dispensario": "Dispensario",
  "ca.barra": "Barra",
  "ca.sinCartaBarra": "Sin carta de barra. Si vendéis bebidas o comida, aquí es donde se enseña la lista.",
  "ca.sinCartaDispensario": "Sin carta del dispensario.",
  "ca.principalAyuda": "La que sale en la pantalla del local",
  "ca.principal": "★ Principal",
  "ca.apagada": "Apagada",
  "ca.creadaEl": "Creada el {fecha}",
  "ca.nCategorias": " · {n} categorías",
  "ca.verQr": "Ver el QR y el enlace",
  "ca.qr": "QR",
  "ca.editar": "Editar",
  "ca.nuevaDe": "+ Carta de {zona}",
  "ca.laPrincipal": "principal",
  "ca.notaPrincipal1": "La",
  "ca.notaPrincipal2":
    "de cada zona es la que sale en la pantalla del local. Las demás se abren con su propio enlace, para poner un QR en las mesas o mandárselo a alguien.",
  "ca.fallo": "No se pudo",
  "ca.n.titulo": "Nueva carta",
  "ca.n.nombreBarra": "Carta de la barra",
  "ca.n.nombreDispensario": "Carta del dispensario",
  "ca.n.crear": "Crear",
  "ca.n.fallo": "No se pudo crear",
  "ca.n.nombre": "Nombre",
  "ca.n.nombreAyuda": "Solo lo veis vosotros, para distinguirlas entre sí.",
  "ca.n.avisoBarra": "Enseñará lo que tengáis dado de alta en la barra.",
  "ca.n.avisoDispensario":
    "Enseñará el género con stock. Después puedes limitarla a unas categorías.",
  "ca.e.nombre": "Nombre",
  "ca.e.mensaje": "Mensaje",
  "ca.e.mensajeAyuda": "Sale arriba del todo. Por ejemplo: horario, o una novedad.",
  "ca.e.categorias": "Categorías que enseña",
  "ca.e.categoriasAyuda": "Ninguna marcada: las enseña todas.",
  "ca.e.encendida": "Encendida",
  "ca.e.encendidaAyuda": "Apagada, su enlace deja de abrir. No se borra nada.",
  "ca.e.ponerlaEnPantalla": "Ponerla en la pantalla del local",
  "ca.e.hacerlaPrincipal": "★ Hacerla principal",
  "ca.e.yaNoLaUsais": "Ya no la usáis",
  "ca.e.confirmarBorrar": "¿Borrar la carta «{nombre}»? Su enlace dejará de abrir.",
  "ca.e.borrar": "Borrar",
  "ca.e.falloBorrar": "No se pudo borrar",
  "ca.e.falloGuardar": "No se pudo guardar",
  "ca.q.titulo": "QR de {nombre}",
  "ca.q.apagada": "Esta carta está apagada: el enlace no abre hasta que la enciendas.",
  "ca.q.enlace": "Enlace",
  "ca.q.siSeHaFiltrado": "Si el enlace se ha filtrado",
  "ca.q.confirmarRenovar": "Se creará un enlace nuevo y el de ahora dejará de abrir. ¿Seguimos?",
  "ca.q.cambiarEnlace": "Cambiar el enlace",
  "ca.q.soloEsta": "Solo cambia el de esta carta. Las demás siguen funcionando.",

  // --- La ficha de un producto ---
  "pd.volver": "Volver",
  "pd.entradasYMermas": "Entradas y mermas",
  "pd.stock": "Stock",
  "pd.minimo": "Mínimo {cantidad}",
  "pd.sinMinimo": "Sin mínimo definido",
  "pd.aportacion": "Aportación",
  "pd.costeMedio": "Coste medio",
  "pd.sinCoste": "Los lotes no tienen coste",
  "pd.segunLotes": "Según los lotes con coste",
  "pd.thcCbd": "THC / CBD",
  "pd.disponible": "Disponible en el mostrador",
  "pd.retirado": "Retirado del mostrador",
  "pd.lotes": "Lotes",
  "pd.sinLotes": "Este producto no tiene lotes: el stock se ha metido por ajuste, sin origen.",
  "pd.lote": "Lote",
  "pd.entrada": "Entrada",
  "pd.origen": "Origen",
  "pd.inicial": "Inicial",
  "pd.queda": "Queda",
  "pd.coste": "Coste",
  "pd.caducidad": "Caducidad",
  "pd.estado": "Estado",
  "pd.consumido": "{n}% consumido",
  "pd.agotado": "Agotado",
  "pd.caducado": "Caducado",
  "pd.enUso": "En uso",
  "pd.ultimosMovimientos": "Últimos movimientos",
  "pd.sinMovimientos": "Sin movimientos.",
  "pd.fecha": "Fecha",
  "pd.tipo": "Tipo",
  "pd.detalle": "Detalle",
  "pd.cantidad": "Cantidad",
  "pd.stockDespues": "Stock después",
  "pd.usuario": "Usuario",

  // --- Recuentos de stock ---
  "re.titulo": "Recuentos",
  "re.descripcion": "Pesar lo que hay y compararlo con lo que debería haber",
  "re.a": "a",
  "re.empezar": "+ Empezar recuento",
  "re.falloEmpezar": "No se pudo empezar el recuento",
  "re.cuadra": "Cuadra",
  "re.enMarcha": "Recuento #{numero} en marcha",
  "re.empezado": "Empezado {cuando} por {quien}. {contados} de {total} contados.",
  "re.alguien": "alguien",
  "re.conLocalCerrado":
    "Cuenta con el local cerrado si puedes. Lo que se dispense mientras tanto no se pierde, pero el descuadre sale más limpio.",
  "re.seguirContando": "Seguir contando",
  "re.delPeriodo": "Recuentos del periodo",
  "re.cerrados": "Cerrados",
  "re.todaviaNinguno": "Todavía ninguno",
  "re.descuadreAcumulado": "Descuadre acumulado",
  "re.sumandoTodos": "Sumando todos los del periodo",
  "re.elPeor": "El peor",
  "re.elDiaQueMas": "El día que más se separó",
  "re.sinCerrados":
    "Sin recuentos cerrados en este periodo. Un recuento es pesar todo lo que hay al cerrar y ver si cuadra con lo que dice el programa.",
  "re.numero": "Nº",
  "re.cuando": "Cuándo",
  "re.quien": "Quién",
  "re.contados": "Contados",
  "re.saltados": "Saltados",
  "re.descuadre": "Descuadre",
  "re.seCorrigio": "Se corrigió",
  "re.tardo": "Tardó",
  "re.si": "Sí",
  "re.no": "No",
  "re.unMinuto": "1 minuto",
  "re.minutos": "{n} minutos",
  "re.ver": "Ver",
  "re.d.titulo": "Recuento #{numero}",
  "re.d.recuento": "Recuento",
  "re.d.seguirLuego": "Seguir luego",
  "re.d.cerrarRecuento": "Cerrar recuento",
  "re.d.contadosDe": "{contados} de {total} contados",
  "re.d.nSaltados": " · {n} saltados",
  "re.d.saltarLoQueQueda": "Saltar lo que queda ({n})",
  "re.d.descuadre": "Descuadre:",
  "re.d.producto": "Producto",
  "re.d.deberiaHaber": "Debería haber",
  "re.d.hay": "Hay",
  "re.d.saltarElResto": "Saltar el resto",
  "re.d.saltado": "Saltado",
  "re.d.volverAContar": "Volver a contarlo",
  "re.d.saltarEste": "Saltar este producto",
  "re.d.contar": "Contar",
  "re.d.saltar": "Saltar",
  "re.d.notas": "Notas:",
  "re.d.seCorrigio": "Al cerrarlo se corrigió el stock con lo contado.",
  "re.d.noSeCorrigio": "Se cerró sin corregir el stock: el descuadre quedó apuntado, nada más.",
  "re.d.falloSaltar": "No se pudo saltar",
  "re.d.falloApuntar": "No se pudo apuntar",
  "re.c.titulo": "Cerrar el recuento",
  "re.c.volver": "Volver",
  "re.c.cerrando": "Cerrando...",
  "re.c.cerrar": "Cerrar",
  "re.c.fallo": "No se pudo cerrar",
  "re.c.hasContadoUno": "Has contado 1 producto y el descuadre es de",
  "re.c.hasContado": "Has contado {n} productos y el descuadre es de", // siempre plural: el singular es re.c.hasContadoUno
  "re.c.corregir": "Corregir el stock con lo contado",
  "re.c.corregirAyuda":
    "Se suma la diferencia a lo que hay ahora, así que si se ha dispensado algo mientras contabas, esa entrega sigue contando. Cada corrección deja su apunte en el inventario.",
  "re.c.notas": "Notas",
  "re.c.notasAyuda": "Por ejemplo: por qué falta, o qué quedó sin mirar.",
  "re.c.noSeBorra": "Un recuento cerrado no se borra: es el papel que explica el descuadre de ese día.",

  // --- El catálogo ---
  "ct.titulo": "Catálogo",
  "ct.descripcion": "Variedades y productos que dispensa el club",
  "ct.importar": "Importar CSV",
  "ct.marcas": "Marcas",
  "ct.nuevaCategoria": "+ Categoría",
  "ct.nuevoProducto": "+ Producto",
  "ct.sinProductos":
    "Todavía no hay productos en el catálogo. Las categorías ya están creadas: solo falta añadir lo que dispensáis, con su aportación.",
  "ct.producto": "Producto",
  "ct.categoria": "Categoría",
  "ct.genetica": "Genética",
  "ct.thcCbd": "THC / CBD",
  "ct.precio": "Aportación",
  "ct.stock": "Stock",
  "ct.estado": "Estado",
  "ct.bajoMinimo": "bajo mínimo",
  "ct.activo": "Activo",
  "ct.inactivo": "Inactivo",
  "ct.editar": "Editar",
  "ct.p.editar": "Editar {nombre}",
  "ct.p.nuevo": "Nuevo producto",
  "ct.p.fallo": "No se pudo guardar el producto",
  "ct.p.nombre": "Nombre",
  "ct.p.categoria": "Categoría",
  "ct.p.marca": "Marca",
  "ct.p.sinMarcasAun": "Todavía no has creado ninguna.",
  "ct.p.sinMarca": "Sin marca",
  "ct.p.genetica": "Genética",
  "ct.p.sinEspecificar": "Sin especificar",
  "ct.p.thc": "THC (%)",
  "ct.p.cbd": "CBD (%)",
  "ct.p.aportacionUnidad": "Aportación por unidad (créditos)",
  "ct.p.aportacionGramo": "Aportación por gramo (créditos)",
  "ct.p.stockMinimo": "Stock mínimo ({unidad})",
  "ct.p.stockMinimoAyuda": "Avisa cuando baje de aquí.",
  "ct.p.precioPorTipo": "Aportación fija por tipo de socio",
  "ct.p.sustituye": "Sustituye a la del catálogo; el descuento del tipo no se aplica encima.",
  "ct.p.vacioConDescuento": "Vacío: catálogo con −{porcentaje}%",
  "ct.p.vacioCatalogo": "Vacío: la aportación del catálogo",
  "ct.p.descripcion": "Descripción",
  "ct.p.disponible": "Disponible en el mostrador",
  "ct.c.titulo": "Nueva categoría",
  "ct.c.fallo": "No se pudo crear la categoría",
  "ct.c.crear": "Crear",
  "ct.c.nombre": "Nombre",
  "ct.c.color": "Color",
  "ct.c.seDispensaPor": "Se dispensa por",
  "ct.c.peso": "Peso (gramos)",
  "ct.c.unidades": "Unidades",
  "ct.m.titulo": "Marcas",
  "ct.m.listo": "Listo",
  "ct.m.fallo": "No se pudo",
  "ct.m.ejemplo": "Cookies, Green House, de casa...",
  "ct.m.anadir": "Añadir",
  "ct.m.sinMarcas":
    "Sin marcas. Sirven para saber de quién es cada género; si cultiváis lo vuestro, esto os sobra.",
  "ct.m.unProducto": "1 producto",
  "ct.m.productos": "{n} productos", // siempre plural: el singular es ct.m.unProducto
  "ct.m.apagada": "Apagada",
  "ct.m.apagar": "Apagar",
  "ct.m.encender": "Encender",
  "ct.m.confirmarConProductos":
    "{productos} se quedarán sin marca. No se borra nada más. ¿Seguimos?",
  "ct.m.confirmarBorrar": "¿Borrar la marca «{nombre}»?",
  "ct.m.borrar": "Borrar",
  "ct.m.nota":
    "Apagarla la quita del desplegable pero deja los productos que ya la tienen. Borrarla los deja sin marca, nada más.",

  // --- Importar el catálogo de un CSV ---
  "ci2.titulo": "Importar catálogo",
  "ci2.descripcion":
    "Trae los productos y el stock que tenéis desde otro programa o desde una hoja de cálculo",
  "ci2.volver": "Volver",
  "ci2.importadoUno": "Importado 1 producto. Ya está en el catálogo y en el mostrador.",
  "ci2.importadoUnoConStock":
    "Importado 1 producto con su stock como lote de entrada. Ya está en el catálogo y en el mostrador.",
  "ci2.importados": "Importados {n} productos. Ya están en el catálogo y en el mostrador.", // siempre plural: el singular es ci2.importadoUno
  "ci2.importadosConStock":
    "Importados {n} productos, {conStock} con su stock como lote de entrada. Ya están en el catálogo y en el mostrador.", // siempre plural: el singular es ci2.importadoUnoConStock
  "ci2.verCatalogo": "Ver el catálogo",
  "ci2.verInventario": "Ver el inventario",
  "ci2.otroFichero": "Importar otro fichero",
  "ci2.paso1": "1. Prepara el fichero",
  "ci2.explicacion":
    "Un CSV con una fila por producto. Se necesitan al menos «Producto», «Categoría» y «Aportación» (por gramo, o por unidad en las categorías que van por unidades). También entiende los nombres en catalán, inglés, neerlandés y alemán, y los que usan otros programas: si tu fichero dice «Precio», «Preu», «Price», «Prijs» o «Preis», lo reconoce igual. Si hay «Stock», entra como un lote con su «Coste», «Proveedor», «Lote» y «Caducidad» si los pones. El resto (THC, CBD, genética, stock mínimo, marca, descripción, activo) se usa si está.",
  "ci2.formatos":
    "Las categorías tienen que existir ya en Catálogo, con su unidad: así una errata no crea una categoría nueva. Números con coma o con punto («8,50» o «8.5»); fechas 2027-03-01 o 01/03/2027; separador «;» o «,». Se aceptan ficheros guardados por Excel.",
  "ci2.descargarPlantilla": "Descargar plantilla",
  "ci2.falloPlantilla": "No se pudo descargar la plantilla",
  "ci2.paso2": "2. Elige el fichero y analízalo",
  "ci2.analizarNoGuarda": "Analizar no guarda nada: solo comprueba el fichero y te dice qué encuentra.",
  "ci2.analizando": "Analizando...",
  "ci2.analizar": "Analizar",
  "ci2.paso3": "3. Resultado",
  "ci2.procesando": "Procesando el fichero...",
  "ci2.eligeFichero": "Elige un fichero y pulsa Analizar.",
  "ci2.filas": "Filas",
  "ci2.validas": "Válidas",
  "ci2.conErrores": "Con errores",
  "ci2.columnas": "Columnas reconocidas: {columnas}",
  "ci2.corrige": "Corrige estas filas en el fichero y vuelve a analizarlo. No se importa nada mientras haya errores.",
  "ci2.fila": "Fila",
  "ci2.problema": "Problema",
  "ci2.producto": "Producto",
  "ci2.categoria": "Categoría",
  "ci2.precio": "Aportación",
  "ci2.stock": "Stock",
  "ci2.seMuestran": "Se muestran {cuantos} de {total}.",
  "ci2.importarUno": "Importar 1 producto",
  "ci2.importarVarios": "Importar {n} productos", // siempre plural: el singular es ci2.importarUno
  "ci2.conStock": " ({n} con stock)",
  "ci2.falloLeer": "No se pudo leer el fichero",
  "ci2.falloImportar": "No se pudo importar",

  // --- Días de apertura ---
  "di.titulo": "Días de apertura",
  "di.descripcion": "Qué días ha abierto el club y cómo fue cada uno",
  "di.a": "a",
  "di.unDiaSinCerrar": "1 día con la caja sin cerrar.",
  "di.diasSinCerrar": "{n} días con la caja sin cerrar.", // siempre plural: el singular es di.unDiaSinCerrar
  "di.arqueoNoCuadra": "El arqueo de esos días no cuadra hasta que se cierren.",
  "di.irACaja": "Ir a Caja",
  "di.diasAbiertos": "Días abiertos",
  "di.deTantos": "{abiertos} de {total}",
  "di.delPeriodo": "Del periodo elegido",
  "di.entradoEnTotal": "Entrado en total",
  "di.entregasBarraCuotas": "Entregas, barra y cuotas",
  "di.sociosDistintos": "Socios distintos",
  "di.hanPasado": "Han pasado por el club",
  "di.soloAbiertos": "Solo los días que abrimos",
  "di.cuandoCuentaAbierto":
    "Un día cuenta como abierto en cuanto alguien ficha, se entrega, se cobra en la barra o se abre una caja.",
  "di.noAbrioNinguno": "El club no abrió ningún día de este periodo.",
  "di.sinDias": "No hay días en el periodo elegido.",
  "di.dia": "Día",
  "di.socios": "Socios",
  "di.entregas": "Entregas",
  "di.dispensado": "Dispensado",
  "di.barra": "Barra",
  "di.cuotas": "Cuotas",
  "di.total": "Total",
  "di.caja": "Caja",
  "di.cerrado": "Cerrado",
  "di.unAlta": "1 alta",
  "di.altas": "{n} altas",
  "di.sinCaja": "Sin caja",
  "di.sinCerrar": "Sin cerrar",
  "di.cuadro": "Cuadró",
  "di.notaTotal":
    "El total suma entregas, barra y cuotas. No incluye los ingresos en cartera, que no son dinero del club, ni resta los gastos.",
  "di.diaYNumero": "{dia} {numero}",

  // --- Control de acceso ---
  "ac.titulo": "Control de acceso",
  "ac.descripcion": "Registro de entrada y salida de socios del local",
  "ac.fallo": "No se pudo registrar el acceso",
  "ac.registrarEntrada": "Registrar entrada",
  "ac.identificar": "Identificar socio...",
  "ac.alElegir":
    "Al elegir un socio se registra su entrada. Si tiene la cuota caducada o está suspendido, el sistema lo avisa y no permite el acceso.",
  "ac.socioNumero": "Socio #{numero}",
  "ac.accesoRegistrado": "Acceso registrado",
  "ac.cartera": "Cartera: {importe}",
  "ac.cuotaValida": "Cuota válida hasta {fecha}",
  "ac.irAlMostrador": "Ir al mostrador",
  "ac.dentroAhora": "Dentro ahora",
  "ac.accesosHoy": "Accesos hoy",
  "ac.enElLocal": "Socios en el local",
  "ac.nadieDentro": "No hay nadie registrado dentro del local.",
  "ac.desde": "desde {hora}",
  "ac.deHoy": "Accesos de hoy",
  "ac.ningunoHoy": "Todavía no se ha registrado ningún acceso hoy.",
  "ac.hora": "Hora",
  "ac.socio": "Socio",
  "ac.tipo": "Tipo",
  "ac.entrada": "Entrada",
  "ac.salida": "Salida",

  // --- El contrato del club ---
  "co2.titulo": "Contrato de socio",
  "co2.descripcion": "La declaración jurada y las normas que firma quien se da de alta",
  "co2.fallo": "No se pudo guardar el contrato",
  "co2.sinCambios": "No has cambiado nada: sigue la versión {numero}.",
  "co2.guardadoConRaros":
    "Guardado como versión {numero}. Ojo: {huecos} no lo sé rellenar y saldrá tal cual en el documento.",
  "co2.guardado": "Guardado como versión {numero}.",
  "co2.sinEscribir":
    "Todavía no has escrito el contrato. Hasta que lo hagas, en las altas no aparecerá nada que firmar y el socio no lo verá en su portal.",
  "co2.versionActual": "Versión actual",
  "co2.numeroVersion": "Nº {numero}",
  "co2.publicada": "Publicada {fecha}",
  "co2.sinEscribirPie": "Sin escribir",
  "co2.loHanFirmado": "Lo han firmado",
  "co2.contandoVersiones": "Socios, contando todas las versiones",
  "co2.sinFirmar": "Sin firmar",
  "co2.faltanDeAlta": "Socios de alta que faltan",
  "co2.ningunoPendiente": "Ninguno pendiente",
  "co2.elTexto": "El texto",
  "co2.elTextoDeHoy": "El texto de hoy",
  "co2.ejemplo": "Declaración jurada\n\nDon/Doña {{NOMBRE}}, con {{DNI}}, declara...",
  "co2.seGuardaTalCual":
    "Se guarda tal como lo escribes, respetando los saltos de línea. Cada vez que cambies el texto nace una versión nueva; la anterior no se borra, porque quien la firmó firmó aquella.",
  "co2.huecos": "Huecos que puedes usar",
  "co2.huecosAyuda": "Escríbelos entre dobles llaves y se rellenan solos con los datos de cada socio.",
  "co2.versiones": "Versiones",
  "co2.sinVersiones": "Todavía no hay ninguna.",
  "co2.numero": "Nº",
  "co2.publicadaColumna": "Publicada",
  "co2.firmas": "Firmas",
  "co2.ver": "Ver",
  "co2.sinFirmarCuantos": "Sin firmar ({n})",
  "co2.socioColumna": "Socio",
  "co2.deAltaDesde": "De alta desde",
  "co2.unSocioDeAntes": "1 socio de antes de escribir el contrato.",
  "co2.sociosDeAntes": "{n} socios de antes de escribir el contrato.", // siempre plural: el singular es co2.unSocioDeAntes
  "co2.seFirmaDesde": "Se firma desde su ficha, o desde el portal si lo tienen abierto.",
  "co2.v.titulo": "Contrato · versión {numero}",
  "co2.v.publicadaEl": "Publicada el {fecha}.",

  // --- Informes ---
  "in.titulo": "Informes",
  "in.descripcion": "Actividad de la asociación en el periodo elegido",
  "in.a": "a",
  "in.porDia": "Por día",
  "in.porMes": "Por mes",
  "in.aportaciones": "Aportaciones",
  "in.unaEntrega": "1 entrega",
  "in.entregas": "{n} entregas", // siempre plural: el singular es in.unaEntrega
  "in.dispensado": "Dispensado",
  "in.cuotasCobradas": "Cuotas cobradas",
  "in.unaCuota": "1 cuota",
  "in.cuotas": "{n} cuotas", // siempre plural: el singular es in.unaCuota
  "in.gastos": "Gastos",
  "in.verDesglose": "Ver desglose",
  "in.evolucion": "Evolución del dispensado",
  "in.sinActividad": "No hay actividad registrada en este periodo.",
  "in.unPeriodo": "1 periodo",
  "in.periodos": "{n} periodos", // siempre plural: el singular es in.unPeriodo
  "in.masDispensados": "Productos más dispensados",
  "in.sinDatos": "Sin datos en el periodo.",
  "in.producto": "Producto",
  "in.cantidad": "Cantidad",
  "in.masActivos": "Socios más activos",
  "in.socio": "Socio",
  "in.visitas": "Visitas",
  "in.queMasAportan": "Los que más aportan",
  "in.nadieHaAportado": "Nadie ha aportado nada en el periodo.",
  "in.enGenero": "{importe} en género",
  "in.enBarra": "{importe} en barra",
  "in.deCuota": "{importe} de cuota",
  "in.donado": "{importe} donado",
  "in.noCuentaCartera":
    "No cuenta lo que hayan metido en su cartera: ese dinero todavía es suyo hasta que se lo gasten.",
  "in.porFormaDePago": "Aportaciones por forma de pago",
  "in.recargasCartera": "Recargas de cartera",
  "in.queOpinan": "Lo que opinan los socios",
  "in.nota": "Nota",
  "in.votos": "Votos",
  "in.queDicen": "Lo que dicen",
  "in.nadieHaEscrito": "Todavía nadie ha escrito nada. Las notas sin comentario sí cuentan para la media.",

  // --- Comunidad: solicitudes de alta y noticias ---
  "cm.titulo": "Comunidad",
  "cm.descripcion": "Solicitudes de alta y noticias para el portal del socio",
  "cm.nuevaNoticia": "+ Noticia",
  "cm.tabSolicitudes": "Solicitudes",
  "cm.tabNoticias": "Noticias",
  "cm.pendientes": "Pendientes",
  "cm.resueltas": "Resueltas",
  "cm.enlaceAlta": "Enlace para solicitar el alta",
  "cm.copiarEnlace": "Copiar enlace",
  "cm.solicitudesPendientes": "Solicitudes pendientes",
  "cm.sinPendientes": "No hay solicitudes pendientes.",
  "cm.recibida": "Recibida",
  "cm.persona": "Persona",
  "cm.contacto": "Contacto",
  "cm.avalista": "Avalista",
  "cm.nacidoEl": "{documento} · nacido el {fecha}",
  "cm.socioNumero": "Socio nº {numero}",
  "cm.aprobar": "Aprobar",
  "cm.rechazar": "Rechazar",
  "cm.aprobada": "{persona} es ahora el socio nº {numero}, pendiente de pagar la cuota.",
  "cm.falloAprobar": "No se pudo aprobar",
  "cm.estado": "Estado",
  "cm.resultado": "Resultado",
  "cm.etiquetaAprobada": "Aprobada",
  "cm.etiquetaRechazada": "Rechazada",
  "cm.sinNoticias": "Sin noticias. Publica una y los socios la verán en su portal.",
  "cm.fecha": "Fecha",
  "cm.tituloColumna": "Título",
  "cm.publicadoPor": "Publicado por",
  "cm.publicada": "Publicada",
  "cm.borrador": "Borrador",
  "cm.editar": "Editar",
  "cm.borrar": "Borrar",
  "cm.confirmarBorrar": "¿Borrar «{titulo}»?",
  "cm.n.editar": "Editar noticia",
  "cm.n.nueva": "Nueva noticia",
  "cm.n.fallo": "No se pudo guardar la noticia",
  "cm.n.titulo": "Título",
  "cm.n.texto": "Texto",
  "cm.n.textoAyuda": "Lo verán los socios en su portal.",
  "cm.n.publicada": "Publicada (si la desmarcas queda como borrador)",
  "cm.n.avisar": "Avisar al móvil de los socios",
  "cm.n.avisarAyuda": "Solo les llega a quienes hayan activado los avisos en su portal.",
  "cm.n.fotos": "Fotos",
  "cm.n.quitar": "Quitar",
  "cm.n.subiendo": "Subiendo…",
  "cm.n.otraFoto": "Añadir otra foto",
  "cm.n.anadirFotos": "Añadir fotos",
  "cm.n.escribePrimero":
    "Escribe primero el título y el texto: la noticia se guarda al añadir la primera foto.",
  "cm.n.hastaOcho": "Hasta 8 fotos. JPG, PNG o WEBP.",
  "cm.n.falloSubir": "No se pudo subir la foto",
  "cm.n.falloQuitar": "No se pudo quitar la foto",
  "cm.r.titulo": "Rechazar la solicitud de {nombre}",
  "cm.r.rechazar": "Rechazar",
  "cm.r.fallo": "No se pudo rechazar",
  "cm.r.queda":
    "La solicitud queda archivada. El motivo es para vuestro registro: el programa no avisa a la persona.",
  "cm.r.motivo": "Motivo (opcional)",

  // --- Ajustes del club ---
  "aj.titulo": "Ajustes",
  "aj.descripcion": "Datos de la asociación, límites y equipo",
  "aj.guardarCambios": "Guardar cambios",
  "aj.guardados": "Ajustes guardados.",
  "aj.fallo": "No se pudieron guardar los ajustes",
  "aj.datos": "Datos de la asociación",
  "aj.nombre": "Nombre",
  "aj.cif": "CIF",
  "aj.telefono": "Teléfono",
  "aj.direccion": "Dirección",
  "aj.ciudad": "Ciudad",
  "aj.provincia": "Provincia",
  "aj.cp": "Código postal",
  "aj.email": "Email de contacto",
  "aj.reglas": "Reglas de dispensación",
  "aj.limiteDiario": "Límite diario (g)",
  "aj.limiteDiarioAyuda": "Por socio y día.",
  "aj.limiteMensual": "Límite mensual (g)",
  "aj.limiteMensualAyuda": "Por socio y mes natural.",
  "aj.cuotaAnual": "Cuota anual (créditos)",
  "aj.limitesPropios": "Cada socio puede tener límites propios que sustituyen a estos.",
  "aj.aforo": "Aforo del local",
  "aj.aforoAyuda":
    "El máximo de personas que caben, según vuestra licencia de actividad. Sale en el mostrador junto a los que hay dentro. Déjalo en 0 si no quieres controlarlo.",
  "aj.aforoNota":
    "Al llegar al aforo se avisa, pero no se impide la entrada: el recuento depende de que la gente marque la salida, y cerrarle la puerta a un socio por un número que puede estar desajustado sería peor que no tenerlo.",
  "aj.ticket": "Ticket de entrega",
  "aj.idiomaPortal": "Idioma del portal del socio",
  "aj.idiomaPortalAyuda":
    "En el que ven el portal y reciben los correos de la cuota. Cada socio puede cambiarlo en su móvil.",
  "aj.anchoPapel": "Ancho del papel",
  "aj.anchoPapelAyuda": "El de la impresora térmica del mostrador.",
  "aj.ancho80": "80 mm (estándar)",
  "aj.ancho58": "58 mm (estrecho)",
  "aj.textoTicket": "Texto del ticket",
  "aj.textoTicketAyuda": "Sale al pie de cada entrega.",
  "aj.avisoLegal": "Aviso legal",
  "aj.avisoCuota": "Aviso automático de cuota",
  "aj.avisoCuotaNota":
    "Una vez al día, el programa avisa por correo (y al móvil, si tienen el portal instalado) a los socios a quienes les vence la cuota. Cada socio recibe un solo aviso por cuota: al renovar, vuelve a entrar el año siguiente.",
  "aj.avisarAuto": "Avisar automáticamente",
  "aj.cuantosDiasAntes": "Cuántos días antes",
  "aj.cuantosDiasAyuda": "Se avisa también a quien ya la tiene vencida.",
  "aj.avisoApagado":
    "Viene apagado a propósito: escribir a vuestros socios es decisión del club, no del programa. Desde Renovaciones podéis mandarlos a mano cuando queráis, aunque esto siga apagado.",
  "aj.equipo": "Equipo",
  "aj.nuevoUsuario": "+ Usuario",
  "aj.usuario": "Usuario",
  "aj.rol": "Rol",
  "aj.ultimoAcceso": "Último acceso",
  "aj.desactivado": "Desactivado",
  "aj.nunca": "Nunca",
  "aj.permisosAMedida": "permisos a medida",

  "permiso.verSocios": "Ver el registro de socios",
  "permiso.crearSocio": "Dar de alta socios",
  "permiso.editarSocio": "Editar la ficha de un socio",
  "permiso.registrarAcceso": "Registrar entradas al local",
  "permiso.dispensar": "Dispensar en el mostrador",
  "permiso.cobrarCuota": "Cobrar cuotas",
  "permiso.recargarCartera": "Recargar la cartera de un socio",
  "permiso.verCatalogo": "Ver el catalogo",
  "permiso.venderBarra": "Cobrar en la barra",
  "permiso.gestionarInventario": "Entradas, mermas y recuentos",
  "permiso.anularDispensacion": "Anular dispensaciones",
  "permiso.suspenderSocio": "Suspender socios",
  "permiso.gestionarCaja": "Abrir y cerrar caja",
  "permiso.gestionarGastos": "Anotar gastos, compras y donaciones",
  "permiso.descuentoManual": "Hacer descuentos a mano en el mostrador",
  "permiso.moverGuardado": "Sacar género del guardado al mostrador",
  "permiso.verInformes": "Ver informes y exportar",
  "permiso.ajustarCartera": "Devolver o ajustar saldo",
  "permiso.gestionarPublicaciones": "Publicar noticias",
  "permiso.gestionarSolicitudes": "Resolver solicitudes de alta",
  "permiso.gestionarCatalogo": "Crear y editar productos",
  "permiso.gestionarBarra": "Gestionar la carta de la barra",
  "permiso.anularCuota": "Anular cuotas cobradas",
  "permiso.gestionarUsuarios": "Gestionar el equipo",
  "permiso.ajustesClub": "Cambiar los ajustes del club",
  "permiso.bajaSocio": "Dar de baja socios",
  "permiso.importarSocios": "Importar socios desde CSV",
  "permiso.importarProductos": "Importar catalogo y stock desde CSV",
  "permiso.verAuditoria": "Ver el registro de actividad",
  "permiso.borrarDatos": "Borrar los datos de un socio",
  "permiso.copiaSeguridad": "Descargar copias de seguridad",

  "aj.cs.titulo": "Cerrar todas las sesiones",
  "aj.cs.explicacion":
    "Echa de todas las pantallas a todo el equipo, tú incluido. Para echar solo a una persona no hace falta esto: desactiva su cuenta aquí arriba y queda fuera igual.",
  "aj.cs.boton": "Cerrar las sesiones del equipo",
  "aj.cs.queVaAPasar":
    "Cada pantalla abierta volverá a pedir la contraseña la próxima vez que hable con el servidor, en unos segundos. La tuya también.",
  "aj.cs.loPendiente":
    "Las entregas ya cobradas que estén sin enviar no se pierden: esperan en la tablet y salen solas en cuanto alguien vuelva a entrar.",
  "aj.cs.confirmar": "Cerrar las sesiones",
  "aj.cs.cerrando": "Cerrando…",
  "aj.cs.fallo": "No se pudieron cerrar las sesiones",
  "aj.editar": "Editar",
  "aj.tiposDeSocio": "Tipos de socio",
  "aj.nuevoTipo": "+ Tipo",
  "aj.sinTipos": "Sin tipos. Crea por ejemplo «Colaborador» con un 10% de descuento y cuota reducida.",
  "aj.tipo": "Tipo",
  "aj.descuento": "Descuento",
  "aj.cuota": "Cuota",
  "aj.dura": "Dura",
  "aj.limites": "Límites",
  "aj.socios": "Socios",
  "aj.laDelClub": "la del club",
  "aj.losDelClub": "los del club",
  "aj.limitesDiaMes": "{diario} / día · {mensual} / mes",
  "aj.registro": "Registro de actividad",
  "aj.sinRegistros": "Sin registros.",
  "aj.sistema": "sistema",
  "aj.copia": "Copia de seguridad",
  "aj.copiaNota":
    "Descarga los datos y guárdalos cifrados fuera del local. Las fotos de los socios están en la carpeta «uploads» del servidor y no van dentro.",
  "aj.copiaDatos": "Datos del club (JSON)",
  "aj.copiaBase": "Base de datos completa (.db)",
  "aj.falloCopia": "No se pudo descargar la copia",
  "aj.variosClubes":
    "La instalación tiene varios clubes: la copia completa del servidor la hace quien lo administra.",
  "aj.copiasAuto": "Copias automáticas",
  "aj.copiasAutoNota": "El programa guarda una copia cada noche y conserva las de los últimos 14 días.",
  "aj.sinCopiasAun":
    "Todavía no hay ninguna: la primera se hace esta noche. Aun así, guarda tú también una fuera del servidor de vez en cuando.",
  "aj.u.titulo": "Nuevo usuario del equipo",
  "aj.u.fallo": "No se pudo crear el usuario",
  "aj.u.crear": "Crear",
  "aj.u.nombre": "Nombre",
  "aj.u.email": "Email",
  "aj.u.contrasena": "Contraseña",
  "aj.u.minimo": "Mínimo 8 caracteres.",
  "aj.u.rol": "Rol",
  "aj.u.trabajadorLargo": "Trabajador — el día a día: mostrador, socios, inventario y caja",
  "aj.e.titulo": "Editar a {nombre}",
  "aj.e.fallo": "No se pudo guardar el usuario",
  "aj.e.nombre": "Nombre",
  "aj.e.rol": "Rol",
  "aj.e.puesto": "Puesto",
  "aj.e.puestoAyuda":
    "Decide en qué caja cae lo que cobra esta persona. Sin puesto, en la caja del club.",
  "aj.e.sinPuesto": "Sin puesto",
  "aj.e.nuevaContrasena": "Nueva contraseña",
  "aj.e.nuevaContrasenaAyuda": "Déjala vacía para no cambiarla. Mínimo 8 caracteres.",
  "aj.e.cuentaActiva": "Cuenta activa",
  "aj.e.noTuPropia": "No puedes desactivar tu propia cuenta.",
  "aj.e.desactivada": "Una cuenta desactivada no puede entrar, pero conserva su historial.",
  "aj.e.permisos": "Permisos",
  "aj.e.permisosAyuda":
    "El rol marca lo que puede hacer por defecto. Aquí puedes hacer excepciones para esta persona: lo que cambies queda resaltado.",
  "aj.e.concedido": "concedido",
  "aj.e.retirado": "retirado",
  "aj.e.volverAlRol": "Volver a los permisos del rol",
  "aj.t.editar": "Editar {nombre}",
  "aj.t.nuevo": "Nuevo tipo de socio",
  "aj.t.fallo": "No se pudo guardar el tipo",
  "aj.t.falloBorrar": "No se pudo borrar el tipo",
  "aj.t.borrar": "Borrar",
  "aj.t.nombre": "Nombre",
  "aj.t.color": "Color",
  "aj.t.descripcion": "Descripción",
  "aj.t.descuento": "Descuento general (%)",
  "aj.t.descuentoAyuda":
    "Sobre la aportación del catálogo, salvo que el producto tenga una aportación fija para este tipo.",
  "aj.t.cuota": "Cuota anual (créditos)",
  "aj.t.cuotaAyuda": "Vacío = la cuota del club. 0 = sin cuota.",
  "aj.t.duracion": "Cuánto dura (meses)",
  "aj.t.duracionAyuda": "12 es lo normal. Con 1, el socio paga cada mes.",
  "aj.t.limiteDiario": "Límite diario (g)",
  "aj.t.limiteDiarioAyuda": "Vacío = el del club.",
  "aj.t.limiteMensual": "Límite mensual (g)",
  "aj.t.orden": "Orden",
  "aj.t.activo": "Activo (se puede asignar a socios nuevos)",
  "aj.p.titulo": "Puestos de trabajo",
  "aj.p.nota":
    "Si en el club se cobra desde más de un sitio a la vez —el mostrador y la barra, cada uno con su cajón—, crea un puesto para cada uno y asigna a cada persona el suyo desde el equipo. Cada puesto abre y cuadra su propia caja.",
  "aj.p.nota2": "Si no creas ninguno, todo sigue como hasta ahora: una sola caja para el club entero.",
  "aj.p.inactivo": " · inactivo",
  "aj.p.unaPersona": "1 persona",
  "aj.p.personas": "{n} personas",
  "aj.p.desactivar": "Desactivar",
  "aj.p.activar": "Activar",
  "aj.p.falloCambiar": "No se pudo cambiar",
  "aj.p.ejemplo": "Mostrador, Barra...",
  "aj.p.anadir": "Añadir",
  "aj.p.fallo": "No se pudo crear el puesto",

  // --- La suscripción del club ---
  "su.titulo": "Tu suscripción",
  "su.prueba": "En periodo de prueba",
  "su.pruebaCaducada": "Prueba terminada",
  "su.alDia": "Al día",
  "su.moroso": "Pendiente de pago",
  "su.suspendido": "Suspendido",
  "su.sinCoste": "Sin coste",
  "su.alMes": "{importe} al mes",
  "su.sinCuota": "Este club no tiene cuota: puedes usar el programa sin pagar nada.",
  "su.bloqueado":
    "La suscripción lleva {dias} sin regularizarse y el programa está en solo lectura. Podéis consultarlo todo y descargar las copias de seguridad; en cuanto se registre el pago vuelve todo.",
  "su.vencioAyer": "Venció ayer. De momento sigue funcionando todo con normalidad.",
  "su.vencioHace": "Venció hace {dias}. De momento sigue funcionando todo con normalidad.",
  "su.pruebaTermina": "La prueba termina el {fecha}, {cuando}.",
  "su.periodoHasta": "El periodo pagado llega hasta el {fecha}, {cuando}.",
  "su.hoy": "hoy",
  "su.manana": "mañana",
  "su.enDias": "en {dias}",
  "su.sinFecha": "No hay ninguna fecha de vencimiento registrada.",
  "su.pagos": "Pagos registrados",
  "su.sinPagos": "Todavía no hay ningún pago registrado.",
  "su.fecha": "Fecha",
  "su.importe": "Importe",
  "su.cubreHasta": "Cubre hasta",
  "su.forma": "Forma",
  "su.recibo": "Recibo",
  "su.metodo.TRANSFERENCIA": "Transferencia",
  "su.metodo.EFECTIVO": "Efectivo",
  "su.metodo.DOMICILIACION": "Domiciliación",
  "su.metodo.TARJETA": "Tarjeta",
  "su.metodo.OTRO": "Otro",
  "su.r.imprimir": "Imprimir o guardar en PDF",
  "su.r.suscripcion": "Suscripción al programa de gestión",
  "su.r.recibidoDe": "Recibido de",
  "su.r.fechaDelPago": "Fecha del pago",
  "su.r.concepto": "Concepto",
  "su.r.conceptoTexto": "Suscripción al programa de gestión, hasta el {fecha}",
  "su.r.formaDePago": "Forma de pago",
  "su.r.importe": "Importe",
  "su.r.justificante":
    "Justificante del pago registrado. No sustituye a la factura, que emite quien presta el servicio.",

  // --- Entrar al programa de gestión ---
  "en.titulo": "Gestión del club",
  "en.subtitulo": "Entra con tu cuenta del equipo",
  "en.email": "Email",
  "en.contrasena": "Contraseña",
  "en.club": "Club",
  "en.eligeClub": "Elige el club...",
  "en.variosClubes": "Ese email pertenece a varios clubes: elige uno.",
  "en.entrando": "Entrando...",
  "en.cola.una":
    "En esta tablet queda una entrega sin enviar: se hizo sin red y saldrá sola en cuanto entres.",
  "en.cola.varias":
    "En esta tablet quedan {cuantas} sin enviar: son entregas que se hicieron sin red y saldrán solas en cuanto entres.",
  "en.entrar": "Entrar",
  "en.fallo": "No se pudo iniciar sesión",
  "en.olvidada": "He olvidado la contraseña",
  "en.aunNoEsta": "¿Vuestro club aún no está?",
  "en.darloDeAlta": "Darlo de alta",
  "en.queEs": "Qué es asocis",

  // --- He olvidado la contraseña ---
  "rc.titulo": "He olvidado la contraseña",
  "rc.subtitulo": "Te mandamos un enlace al correo de tu cuenta",
  "rc.email": "Email",
  "rc.enviando": "Enviando...",
  "rc.enviar": "Enviarme el enlace",
  "rc.fallo": "No se pudo enviar el correo",
  "rc.miraSpam": "Mira también en la carpeta de correo no deseado. El enlace caduca en una hora.",
  "rc.volver": "Volver a la entrada",
  "rc.nueva": "Nueva contraseña",
  "rc.cambiada": "Contraseña cambiada. Te llevamos a la entrada...",
  "rc.entrarAhora": "Entrar ahora",
  "rc.nuevaEtiqueta": "Contraseña nueva",
  "rc.minimo": "Mínimo 8 caracteres.",
  "rc.repitela": "Repítela",
  "rc.noCoinciden": "Las dos contraseñas no coinciden.",
  "rc.cambiar": "Cambiar la contraseña",
  "rc.falloCambiar": "No se pudo cambiar la contraseña",

  // --- Dar de alta un club ---
  "rg.cerrado": "Alta de clubes cerrada",
  "rg.cerradoTexto":
    "Esta instalación no admite crear clubes nuevos desde la web. Habla con quien administra el servidor para que te dé acceso.",
  "rg.volverAEntrar": "Volver a entrar",
  "rg.titulo": "Dar de alta un club",
  "rg.subtitulo": "Creas la asociación y tu cuenta de propietario",
  "rg.nombreClub": "Nombre de la asociación",
  "rg.nombreClubEjemplo": "Asociación Cannábica...",
  "rg.ciudad": "Ciudad",
  "rg.tuNombre": "Tu nombre",
  "rg.tuEmail": "Tu email",
  "rg.tuEmailAyuda": "Será tu usuario para entrar.",
  "rg.contrasena": "Contraseña",
  "rg.minimo": "Mínimo 8 caracteres.",
  "rg.repite": "Repite la contraseña",
  "rg.codigo": "Código de licencia",
  "rg.codigoAyuda": "El que te dieron al contratar. Tiene esta forma: ASOC-XXXX-XXXX.",
  "rg.acepto": "He leído y acepto el",
  "rg.avisoLegal": "aviso legal",
  "rg.yLa": "y la",
  "rg.privacidad": "política de privacidad",
  "rg.creando": "Creando el club...",
  "rg.crear": "Crear el club",
  "rg.yaTeneis": "¿Ya tenéis club?",
  "rg.entrar": "Entrar",
  "rg.noCoinciden": "Las dos contraseñas no coinciden",
  "rg.fallo": "No se pudo crear el club",
} as const;

export type Clave = keyof typeof es;
